const siteData = {
  plantation: [
    {
      id: 61,
      name: "Rippon Tea estate",
      description: "Tea plantations around Ripon junction in Muppainad, near Meppadi, on the hill road south of Kalpetta.",
      image: [
        "https://www.bwstays.com/assets/img/plantation/bw-hotel-tea-plantation-wayanad.webp",
        "https://www.bwstays.com/assets/img/plantation/bw-stays-tea-vythiri-wayanad.webp",
        "https://www.bwstays.com/assets/img/plantation/bw-stays-tea-kalpetta-wayanad.webp",
        "https://www.bwstays.com/assets/img/plantation/bw-hotel-tea-plantaion-tour-wayanad.webp",
        "https://www.bwstays.com/assets/img/plantation/bw-stays-estate-green-stay-kalpetta-wayanad.webp",
      ],
      holidays: "NA",
      timing: [],
      Contact: "",
      seasontovisit: [
        "Summer (March-May)",
        "Monsoon (June-September)",
        "Winter (October-February)",
      ],
      distance: "17",
      transport: "Public",
      latlong: "11.534836134024715, 76.17498437471619",
      map: "https://www.google.com/maps/place/Ripon+Tea+Factory/@11.5349821,76.1790317,17z",
      rating: "",
      hrs: "2",
      fee: "",
      aliases: [],
      content:
        "The Rippon (Ripon) estate area lies around Ripon junction in Muppainad panchayat, about 7 km from Meppadi, with a tea factory and an estate bungalow. It is a working private plantation; no official visitor hours, factory-tour schedule or fee are published.",
      amenities: [
        "Tea Estate Views",
        "Tea Factory",
      ],
      tags: [
        "tea plantation",
        "tea factory",
        "meppadi",
        "muppainad",
        "estate",
      ],
      type: "Plantations",
      knowmore:
        "https://www.bwstays.com/bw-rippon-tea-estate-plantation-wayanad.html",
      duration: "1-2 Hours",
      www: "",
    },
    {
      id: 98,
      name: "Priyadarshini Hills (Priyadarshini Tea Environs)",
      description: "Tea estate of a cooperative society for formerly bonded tribal families, about 9 km from Mananthavady, with tea tours, a tea factory and treks.",
      image: [
        "https://www.bwstays.com/assets/img/plantation/bw-priyadarshini-tea-environs-mananthavady-wayanad.webp",
      ],
      holidays: "NA",
      timing: ["09:00-17:00"],
      Contact: "+91 94957 47900",
      seasontovisit: [
        "Winter (October-February)",
        "Summer (March-May)",
      ],
      distance: "39",
      transport: "",
      latlong: "11.86066, 75.99107",
      map: "https://www.openstreetmap.org/way/1123284968",
      rating: "",
      hrs: "",
      fee: "Adult INR 100, child INR 50",
      aliases: ["priyadarshini tea estate", "priyadarshini tea environs", "priyadharshini", "pancharakolly"],
      content:
        "Priyadarshini Tea Environs at Pancharakolly, near Mananthavady, is run by a cooperative society for the rehabilitation of the bonded tribal people of Wayanad district (Kerala Tourism). DTPC Wayanad describes a walk through the plantation, a visit to the tea factory, tea tasting and tea to buy; trekking, mountain biking, hiking and camping are also offered, and a trek leads to Vishwas Point, the highest point of the estate (Kerala Tourism). Rooms and tree houses can be booked; DTPC says only offline booking is available. Best time: October to May (DTPC). Mananthavady bus stand is about 9 km away.",
      amenities: [
        "Tea Factory Tour",
        "Tea Tasting",
        "Trekking",
        "Camping",
        "Stay",
      ],
      tags: [
        "tea plantation",
        "tea factory",
        "tea tour",
        "mananthavady",
        "tribal cooperative",
        "trekking",
      ],
      type: "Plantations",
      knowmore:
        "https://www.bwstays.com/bw-priyadarshini-tea-environs-plantation-wayanad.html",
      duration: "",
      www: "",
    },
    {
      id: 99,
      name: "Harrisons Malayalam Tea Estate, Arrapetta",
      description: "Harrisons Malayalam tea estate at Arrapetta, near Meppadi, with its own factory making orthodox tea.",
      image: [
        "https://www.bwstays.com/assets/img/plantation/bw-arrapetta-tea-estate-meppadi-wayanad.webp",
      ],
      holidays: "NA",
      timing: [],
      Contact: "",
      seasontovisit: [],
      distance: "15",
      transport: "",
      latlong: "11.53901, 76.1585",
      map: "https://www.openstreetmap.org/way/859673805",
      rating: "",
      hrs: "",
      fee: "",
      aliases: ["arrapetta", "arapetta", "harrisons", "harrison estate", "hml estate"],
      content:
        "Arrapetta Estate (Meppadi Post) is one of the Wayanad tea estates of Harrisons Malayalam Ltd, which lists it as making orthodox tea, about two million kg a year, in its Wynaad estates at 2,500 to 3,500 feet. OpenStreetMap shows the Mele Arapetta tea factory and an HML estate bungalow at Thinapuram, east of Meppadi, close to the Ripon tea estate. It is a working private plantation: no visitor hours, factory tours or fees are published, so enjoy the estate roads and views from the public road.",
      amenities: [
        "Tea Estate Views",
        "Tea Factory",
      ],
      tags: [
        "tea plantation",
        "harrisons malayalam",
        "orthodox tea",
        "meppadi",
        "estate",
      ],
      type: "Plantations",
      knowmore:
        "https://www.bwstays.com/bw-arrapetta-tea-estate-plantation-wayanad.html",
      duration: "",
      www: "https://harrisonsmalayalam.com/",
    },
    {
      id: 49,
      name: "Chundale Tea Estate (Harrisons Malayalam)",
      description: "Harrisons Malayalam tea estate at Chundale, about 7 km south of Kalpetta on the Meppadi road, with its own CTC tea factory.",
      image: [
        "https://www.bwstays.com/assets/img/cycling/bw-stays-chundale-cycling-group-wayanad.webp",
        "https://www.bwstays.com/assets/img/cycling/bw-stays-chundale-cycling-hotel-wayanad.webp",
        "https://www.bwstays.com/assets/img/cycling/bw-stays-resort-wayanad-cycle-workation.webp",
        "https://www.bwstays.com/assets/img/cycling/bw-hotel-stays-chundale-wayanad.webp",
      ],
      holidays: "NA",
      timing: [],
      Contact: "",
      seasontovisit: ["Summer (March-May)", "Winter (October-February)"],
      distance: "7",
      latlong: "11.57785, 76.053",
      map: "https://www.openstreetmap.org/way/485874633",
      transport: "Public",
      rating: "",
      hrs: "2",
      fee: "",
      aliases: ["chundale", "chundail", "chundale estate", "harrisons"],
      content:
        "Chundale, a few kilometres south of Kalpetta, is surrounded by tea estates; Harrisons Malayalam lists Chundale Estate (Chundale Post, 673 123) among its Wayanad gardens, making CTC tea, about two million kg a year. OpenStreetMap shows the Chundale Tea Factory and the estate land beside the Kalpetta-Meppadi road. It is a working private plantation, so visitors keep to public roads unless an estate offers a tour; no visitor hours or fees are published.",
      amenities: [
        "Tea Estate Views",
        "Tea Factory",
        "Estate Roads",
      ],
      tags: [
        "tea plantation",
        "harrisons malayalam",
        "ctc tea",
        "chundale",
        "estate",
      ],
      type: "Plantations",
      knowmore:
        "https://www.bwstays.com/bw-chundale-tea-estate-plantation-wayanad.html",

      duration: "1-2 Hours",
      www: "",
    },
  ],

  waterfalls: [
    {
      id: 33,
      name: "Meenmutty Falls",
      description:
        "Three-tier waterfall about 5 km from Banasura Sagar Dam, with a total drop that DTPC gives as over 800 ft.",
      image: [
        "https://www.bwstays.com/assets/img/falls/bw-stays-meenmutty-homestay-wayanad.webp",
        "https://www.bwstays.com/assets/img/falls/bw-stays-meenmutty-waterfall-wayanad.webp",
        "https://www.bwstays.com/assets/img/falls/bw_meenmufalls_wayanad2.webp",
        "https://www.bwstays.com/assets/img/falls/bw-stays-meenmutty-falls-wayanad.webp",
      ],
      holidays: "NA",
      timing: ["10:00-17:00"],
      Contact: "+91 85476 02722",
      seasontovisit: [
        "Summer (March-May)",
        "Monsoon (June-September)",
        "Winter (October-February)",
      ],
      distance: "25",
      transport: "Public",
      rating: "",
      hrs: "2",
      fee: "Adult INR 100, student INR 50, foreigner INR 200",
      aliases: ["meenmutty", "meenmutty falls"],
      latlong: "11.677845397531414, 75.93568600923",
      map: "https://www.google.com/maps/place/Makkiyad+Meenmutty+Water+Falls/@11.7282012,75.8861335,17z",
      content:
        "The first tier is a short walk from the parking ground, the second is reached by steps built over boulders, and the third needs a stream crossing over slippery rocks with ropes. The top gives views of Banasura Sagar Dam and the valleys. Do not confuse it with the Meenmutty falls near Meppadi, which is closed to visitors.",
      amenities: ["Waterfalls", "Lakes", "Canals", "Local Culture"],
      tags: [
        "kalpetta",
        "waterfalls",
        "canals",
        "lakes",
        "lagoons",
        "tranquil",
        "authentic",
      ],

      type: "Water Falls",
      knowmore: "https://www.bwstays.com/bw-meenmutty-waterfall-wayanad.html",
      duration: "1-2 Hours",
      www: "",
    },

    {
      id: 35,
      name: "Soochipara Falls",
      description:
        "Three-tier forest waterfall near Meppadi, also called Sentinel Rock, about 23 km from Kalpetta; daily visitor numbers are capped.",
      image: [
        "https://www.bwstays.com/assets/img/falls/bw-service-apartment-soochipara-wayanad.webp",
        "https://www.bwstays.com/assets/img/falls/bw-homestay-soojipara-waterfalls-wayanad.avif",
      ],
      holidays: "NA",
      timing: ["08:00-17:00"],
      Contact: "+91 85472 37513",
      seasontovisit: [
        "Summer (March-May)",
        "Monsoon (June-September)",
        "Winter (October-February)",
      ],
      distance: "23",
      transport: "Public",
      rating: "",
      hrs: "2",
      fee: "Adult INR 150, student INR 50, foreigner INR 300",
      aliases: ["soochipara", "sentinel rock"],
      latlong: "11.51173007949638, 76.16378589573601",
      map: "https://www.google.com/maps/place/Soochipara+Waterfalls/@11.5115356,76.1637859,17z",
      content:
        "Soochipara falls in three tiers; the name comes from a needle-shaped cliff nearby that is used for rock climbing. DTPC limits entry to 500 visitors a day between 08:00 and 17:00, and tickets are sold at the counter only. Children under 10 enter free.",
      amenities: ["Waterfalls", "Lakes", "Canals", "Local Culture"],
      tags: [
        "kalpetta",
        "waterfalls",
        "canals",
        "lakes",
        "lagoons",
        "tranquil",
        "authentic",
      ],
      type: "Water Falls",
      knowmore: "https://www.bwstays.com/bw-soochipara-waterfall-wayanad.html",
      duration: "1-2 Hours",
      www: "",
    },
    {
      id: 37,
      name: "Kanthanpara Falls",
      description:
        "Waterfall of about 100 ft on the Vaduvanchal road, 8 km from Meppadi, beside the Meppadi forest range.",
      image: [
        "https://www.bwstays.com/assets/img/falls/bw-stays-kanthanpara-waterfalls-wayanad.webp",
        "https://www.bwstays.com/assets/img/falls/black-and-white-kanthanpara-falls-wayanad.webp",
        "https://www.bwstays.com/assets/img/falls/bw-stays-kanthanpara-waterfalls-kalpetta.webp",
        "https://www.bwstays.com/assets/img/falls/bw-stays-kanthanpara-waterfalls.webp",
      ],
      holidays: "NA",
      timing: ["09:00-16:30"],
      Contact: "+91 493 621 5342, +91 75938 92953",
      seasontovisit: [
        "Summer (March-May)",
        "Monsoon (June-September)",
        "Winter (October-February)",
      ],
      distance: "18",
      transport: "Public",
      rating: "",
      hrs: "2",
      fee: "Adult INR 40, child INR 30",
      aliases: [],
      latlong: "11.5239348, 76.1526896",
      map: "https://www.google.com/maps/place/Kanthanpara+Waterfalls/@11.5239348,76.1526896,17z",
      content:
        "Kanthanpara is a smaller waterfall, about 100 ft high, on the Vaduvanchal road 8 km from Meppadi and about 19 km from Kalpetta, close to the Meppadi range of the South Wayanad Forest Division. DTPC mentions an optional trek of about two hours along the Kanthanpara river.",
      amenities: ["Waterfalls", "Lakes", "Canals", "Local Culture"],
      tags: [
        "kalpetta",
        "waterfalls",
        "canals",
        "lakes",
        "lagoons",
        "tranquil",
        "authentic",
      ],
      type: "Water Falls",
      knowmore: "https://www.bwstays.com/bw-kanthanpara-waterfall-wayanad.html",

      duration: "1-2 Hours",
      www: "",
    },
    {
      id: 40,
      name: "Arripara falls",
      description:
        "Waterfall on the Iruvanji river near Thiruvambady in Kozhikode district, about 15 km from Thiruvambady town.",
      image: [
        "https://www.bwstays.com/assets/img/falls/bw-stays-arripa-falls-kalpetta.webp",
      ],
      holidays: "NA",
      timing: ["10:00-17:00"],
      Contact: "+91 94969 24566",
      seasontovisit: [
        "Summer (March-May)",
        "Monsoon (June-September)",
        "Winter (October-February)",
      ],
      distance: "37",
      transport: "Public",
      rating: "",
      hrs: "2",
      fee: "Adults INR 10, children INR 5",
      aliases: [],
      latlong: "11.43840307285013, 76.04597666931055",
      map: "https://www.google.com/maps/place/Arippara+Waterfalls/@11.4381875,76.0460625,17z",
      content:
        "Arippara drops in several levels over rock and boulders into natural pools, about 15 km from Thiruvambady and 12 km from Thusharagiri falls. Kerala Tourism advises visiting between November and May because the monsoon flow makes it risky.",
      amenities: ["Waterfalls", "Lakes", "Canals", "Local Culture"],
      tags: [
        "kalpetta",
        "waterfalls",
        "canals",
        "lakes",
        "lagoons",
        "tranquil",
        "authentic",
      ],
      type: "Water Falls",
      knowmore: "https://www.bwstays.com/bw-arripara-waterfall-wayanad.html",

      duration: "1-2 Hours",
      www: "",
    },
    {
      id: 41,
      name: "Irrupu falls ",
      description:
        "Waterfall of about 170 ft on the Lakshmana Tirtha river in the Brahmagiri Hills of Kodagu, Karnataka, near the Wayanad border.",
      image: [
        "https://www.bwstays.com/assets/img/falls/bw-stays-irupu-falls-wayanad-inn.webp",
      ],
      holidays: "NA",
      timing: [],
      Contact: "",
      seasontovisit: [
        "Summer (March-May)",
        "Monsoon (June-September)",
        "Winter (October-February)",
      ],
      distance: "60",
      transport: "Public",
      rating: "",
      hrs: "2",
      fee: "",
      aliases: [],
      latlong: "11.967284462093113, 75.98393572809631",
      map: "https://www.google.com/maps/place/Iruppu+Falls/@11.96706,75.9839414,17z",
      content:
        "Iruppu falls about 170 ft from the Lakshmana Tirtha river; legend says Lakshmana shot an arrow into the hill to bring out the stream. The Rameshwara temple on the trail draws pilgrims, especially at Shivaratri. A walk of about 1 km leads to the falls, which Karnataka Tourism says are open all year; the flow is lowest from December to February.",
      amenities: ["Waterfalls", "Lakes", "Canals", "Local Culture"],
      tags: [
        "kalpetta",
        "waterfalls",
        "canals",
        "lakes",
        "lagoons",
        "tranquil",
        "authentic",
      ],
      type: "Water Falls",
      knowmore: "https://www.bwstays.com/bw-irrupu-waterfall-wayanad.html",

      duration: "1-2 Hours",
      www: "",
    },
    {
      id: 42,
      name: "Chetalayam falls  ",
      description:
        "Small seasonal waterfall in forest about 12 km from Sulthan Bathery, reached on foot; it runs low or dry in summer.",
      image: [
        "https://www.bwstays.com/assets/img/falls/bw-stays-chethalayam-waterfall-homestay.webp",
        "https://www.bwstays.com/assets/img/falls/black-and-white-chethalayam-falls-wayanad.webp",
      ],
      holidays: "NA",
      timing: [],
      Contact: "",
      seasontovisit: [
        "Summer (March-May)",
        "Monsoon (June-September)",
        "Winter (October-February)",
      ],
      distance: "34",
      transport: "Public",
      rating: "",
      hrs: "2",
      fee: "",
      aliases: [],
      latlong: "11.765721623585334, 76.25204562883619",
      map: "https://www.google.com/maps/place/Chethalayam+Waterfalls/@11.7654958,76.2520349,17z",
      content:
        "Chethalayam is one of the smaller and less-visited falls of Wayanad, set in forest near Sulthan Bathery and reached by a trek through woodland. A cascade drops into a clear pool. It is seasonal: Kerala Tourism notes it dries up in summer, so it is best seen in or after the monsoon.",
      amenities: ["Waterfalls", "Lakes", "Canals", "Local Culture"],
      tags: [
        "kalpetta",
        "waterfalls",
        "canals",
        "lakes",
        "lagoons",
        "tranquil",
        "authentic",
      ],
      type: "Water Falls",
      knowmore: "https://www.bwstays.com/bw-chetalayam-waterfall-wayanad.html",

      duration: "1-2 Hours",
      www: "",
    },

    {
      id: 16,
      name: "Thusharagiri",
      description: "Three waterfalls near Kodenchery in Kozhikode district, the tallest dropping about 75 m, within a few hundred metres of each other.",
      image: [
        "https://www.bwstays.com/assets/img/falls/bw-stays-thusharagiri-falls-service-apartment.webp",
      ],
      holidays: "NA",
      timing: ["06:00-18:00"],
      Contact: "",
      seasontovisit: [
        "Summer (March-May)",
        "Monsoon (June-September)",
        "Winter (October-February)",
      ],
      distance: "31",
      transport: "Public",
      latlong: "11.472979462955495, 76.05414413068944",
      map: "https://www.google.com/maps/place/Thusharagiri+Waterfalls/@11.4728749,76.0541761,17z",
      rating: "",
      hrs: "2",
      fee: "INR 30 per person",
      aliases: [],
      content:
        "Thusharagiri has three falls: Erattumukku, Mazhavil Chattom and Thumbithullumpara (Thenpara), 100-500 m apart. The tallest drops about 75 m. Forest trails lead to the upper falls. It is in Kozhikode district, about 50 km from Kozhikode city, and is managed with DTPC Kozhikode.",
      amenities: ["Waterfalls", "Lakes", "Canals", "Local Culture"],
      tags: [
        "kalpetta",
        "waterfalls",
        "canals",
        "lakes",
        "lagoons",
        "tranquil",
        "authentic",
      ],
      type: "Water Falls",
      knowmore:
        "https://www.bwstays.com/bw-thusharagiri-waterfall-wayanad.html",

      duration: "1-2 Hours",
      www: "",
    },
  ],
  museums: [
    {
      id: 52,
      name: "Gandhi Museum",
      description: "A small Gandhi memorial museum and library at Puliyarmala, about 4 km from Kalpetta, beside the Ananthanatha Swamy Jain temple.",
      image: [
        "https://www.bwstays.com/assets/img/museum/bw-stays-kalpetta-gandhi-museum.webp",
      ],
      holidays: "NA",
      timing: [],
      Contact: "",
      seasontovisit: [
        "Summer (March-May)",
        "Monsoon (June-September)",
        "Winter (October-February)",
      ],
      distance: "4",
      transport: "Public",
      rating: "",
      hrs: "2",
      fee: "",
      aliases: [],
      latlong: "11.641044660114158, 76.08687012883617",
      map: "https://www.google.com/maps/search/?api=1&query=Gandhi+Museum+Puliyarmala+Kalpetta+Wayanad+Kerala",

      content:
        "The museum occupies the boarding house near the Puliyarmala Jain temple where Mahatma Gandhi rested; Wikipedia records his visit to Kalpetta on 14 January 1934. It holds a memorial and a library about his life. No official opening hours, fee or contact are published.",
      amenities: ["Memorial museum", "Beside the Ananthanatha Swamy Jain temple"],
      tags: ["gandhi", "gandhi museum", "museum", "puliyarmala", "kalpetta", "jain temple", "heritage"],

      type: "Museums & Crafts",
      knowmore: "https://www.bwstays.com/bw-stays-kalpetta-gandhi-museum.html",

      duration: "1-2 Hours",
      www: "",
    },
    {
      id: 89,
      name: "Kungichira Museum & Chira",
      description: "Kungichira Museum & Chira.",
      image: [
        "https://www.bwstays.com/assets/img/museum/bw-kunkichira-heritage-museum-at-periya-wayanad.webp",
      ],
      holidays: "NA",
      timing: [],
      Contact: "",
      seasontovisit: [
        "Summer (March-May)",
        "Monsoon (June-September)",
        "Winter (October-February)",
      ],
      distance: "12",
      transport: "Public",
      rating: "",
      hrs: "2",
      fee: "",
      aliases: [],
      latlong: "11.600747990313033, 76.0148553711638",
      map: "https://www.google.com/maps/place/Wayanad+Tea+Museum/@11.6005956,76.0148661,17z",

      content:
        "Stay in a beautifully restored service apartment in the heart of Wayanad. Explore nearby spice markets, traditional shopping, and historic landmarks. Walking distance to Spice market and local eateries serving authentic Kerala dishes.",
      amenities: [
        "WiFi",
        "Villa Architecture",
        "museums",
        "Central Location",
        "Guided Tours",
      ],
      tags: [
        "heritage",
        "colonial",
        "kalpetta",
        "spice markets",
        "art",
        "historic",
        "jain temple",
        "kerala dishes",
      ],

      type: "Museums & Crafts",
      knowmore:
        "https://www.bwstays.com/all-locations-wayanad.html",

      duration: "1-2 Hours",
      www: "",
    },
    {
      id: 26,
      name: "Tea Museum, Achoor (Harrisons Malayalam)",
      description:
        "Tea museum in the Achoor Estate of Harrisons Malayalam at Achoor, near Pozhuthana, on the history of tea growing in Wayanad.",
      image: [
        "https://www.bwstays.com/assets/img/museum/bw-stays-wayanad-tea-museum.webp",
      ],
      holidays: "NA",
      timing: ["09:00-18:00"],
      Contact: "",
      seasontovisit: [
        "Summer (March-May)",
        "Monsoon (June-September)",
        "Winter (October-February)",
      ],
      distance: "12",
      transport: "Public",
      rating: "",
      hrs: "2",
      fee: "",
      aliases: [],
      latlong: "11.600747990313033, 76.0148553711638",
      map: "https://www.google.com/maps/place/Wayanad+Tea+Museum/@11.6005956,76.0148661,17z",

      content:
        "The museum covers about a century of tea growing in the region, with old machinery, tools and early photographs of the tea industry. Visitors can follow the process from green leaf to tea powder, taste several teas and buy Achoor estate tea on site. A 2018 news report says it occupies a renovated old tea factory on three floors.",
      amenities: [
        "WiFi",
        "Villa Architecture",
        "museums",
        "Central Location",
        "Guided Tours",
      ],
      tags: [
        "heritage",
        "colonial",
        "kalpetta",
        "spice markets",
        "art",
        "historic",
        "jain temple",
        "kerala dishes",
      ],

      type: "Museums & Crafts",
      knowmore: "https://www.bwstays.com/bw-tea-museum-wayanad.html",

      duration: "1-2 Hours",
      www: "",
    },
    {
      id: 78,
      name: "Honey Museum",
      description: "Private museum on honey and beekeeping at Old Vythiri, run by Beecraft, with displays on bees and honey collection and a honey shop.",
      image: [
        "https://www.bwstays.com/assets/img/museum/bw-stays-honey-museum-wayanad.webp",
      ],
      holidays: "NA",
      timing: ["09:30-18:30 (Mon-Fri)"],
      Contact: "+91 92070 79001",
      seasontovisit: ["All Season"],
      distance: "12",
      transport: "Public",
      latlong: "11.5375175, 76.0434972",
      map: "https://www.google.com/maps/place/Honey+Museum+Wayanad/@11.5375153,76.0435405,17z",
      rating: "",
      hrs: "2",
      fee: "INR 30 (guided tour)",
      aliases: [],

      content:
        "The museum, listed as the Beecraft Honey Museum at Old Vythiri, presents how honey is produced and gathered, with sections on honey bees and their habitat, and a tasting and sales area. Opening hours and fees differ between third-party listings and were not found on an official page.",
      amenities: [
        "WiFi",
        "Villa Architecture",
        "museums",
        "Central Location",
        "Guided Tours",
      ],
      tags: [
        "heritage",
        "colonial",
        "kalpetta",
        "spice markets",
        "art",
        "historic",
        "jain temple",
        "kerala dishes",
      ],

      type: "Museums & Crafts",
      knowmore: "https://www.bwstays.com/bw-honey-museum-wayanad.html",

      duration: "1-2 Hours",
      www: "",
    },
    {
      id: 27,
      name: "Wayanad Heritage Museum",
      description:
        "Archaeological and heritage museum at Ambalavayal with tribal artefacts, hero stones and finds from the Neolithic age onwards.",
      image: [
        "https://www.bwstays.com/assets/img/museum/bw-guesthouse-wayanad-heritage-museum-ambalavayal.webp",
        "https://www.bwstays.com/assets/img/museum/bw-stays-wayanad-heritage-homestay.webp",
        "https://www.bwstays.com/assets/img/museum/bw-stays-wayanad-heritage-museum.webp",
      ],
      holidays: "NA",
      timing: ["09:00-17:30"],
      Contact: "+91 493 629 4668, +91 75938 92955",
      seasontovisit: [
        "Summer (March-May)",
        "Monsoon (June-September)",
        "Winter (October-February)",
      ],
      distance: "",
      transport: "Public",
      rating: "",
      hrs: "2",
      fee: "Adult INR 30, child INR 20; multimedia show INR 50",
      aliases: [],
      latlong: "",
      map: "https://www.google.com/maps/search/?api=1&query=Wayanad+Heritage+Museum+Ambalavayal",

      content:
        "The Wayanad Heritage Museum at Ambalavayal, about 12 km from Sultan Bathery, holds artefacts found in the Wayanad area in four blocks: Veerasmruthi (hero stones and warrior memorials), Gothrasmruthi and Jeevanusmruthi (tribal life) and Devasmruthi (objects from the Neolithic age to the 17th century). Entry 9:00 am to 5:30 pm; adults INR 30, children INR 20 (DTPC Wayanad).",
      amenities: [
        "WiFi",
        "Villa Architecture",
        "museums",
        "Central Location",
        "Guided Tours",
      ],
      tags: [
        "heritage",
        "colonial",
        "kalpetta",
        "spice markets",
        "art",
        "historic",
        "jain temple",
        "kerala dishes",
      ],

      type: "Museums & Crafts",
      knowmore: "https://www.bwstays.com/bw-folklore-museum-wayanad.html",

      duration: "1-2 Hours",
      www: "",
    },
  ],
  romantic: [
    {
      id: 43,
      name: "Karapuzha Dam",
      description: "Earth dam 625 m long and 28 m high on the Karapuzha river, built for irrigation, with gardens and an adventure park.",
      image: [
        "https://www.bwstays.com/assets/img/romantic/bw-staycation-karapuzha-dam.webp",
        "https://www.bwstays.com/assets/img/romantic/bw-service-apartment-wayanad-karappuzha-dam.webp",
      ],
      holidays: "NA",
      timing: ["09:00-18:00"],
      Contact: "+91 493 620 2246",
      seasontovisit: [
        "Summer (March-May)",
        "Monsoon (June-September)",
        "Winter (October-February)",
      ],
      distance: "16",
      transport: "Public",
      rating: "",
      hrs: "2",
      fee: "Adult INR 30, child INR 10",
      aliases: [],
      latlong: "11.6182113, 76.1722152",
      map: "https://www.google.com/maps/place/Karapuzha+Reservoir/@11.6099276,76.1660561,17z",
      content:
        "Karapuzha is an earthen irrigation dam, 625 m long and 28 m high, on the Karapuzha river. The DTPC park beside the reservoir has landscaped gardens and walkways, a children's park, a watchtower, boating and paid rides such as a zipline, giant swing and VR zone. The reservoir area is also visited for birdwatching.",
      amenities: [
        "Mountain View",
        "Private Pool",
        "Yoga Classes",
        "Ayurvedic Spa",
      ],
      tags: [
        "Ghats",
        "kalpetta",
        "Deccan Plateau",
        "seafood",
        "yoga",
        "cliff",
        "ayurvedic",
        "spice shops",
      ],

      type: "Romantic Spots",
      knowmore:
        "https://www.bwstays.com/bw-karapuzha-dam-romantic-wayanad.html",

      duration: "1-2 Hours",
      www: "",
    },

    {
      id: 39,
      name: "Karlad Lake",
      description:
        "Natural freshwater lake at Thariode, 3 km from Banasura Sagar Dam, home to DTPC's Wayanad Adventure Camp with a zipline over the water.",
      image: [
        "https://www.bwstays.com/assets/img/romantic/bw-stays-karlad-lake-wayanad-tourism.webp",
        "https://www.bwstays.com/assets/img/romantic/bw-rooms-karlad-lake-wayanad.webp",
      ],
      holidays: "NA",
      timing: ["09:00-17:00"],
      Contact: "",
      seasontovisit: [
        "Summer (March-May)",
        "Monsoon (June-September)",
        "Winter (October-February)",
      ],
      distance: "21",
      transport: "Public",
      rating: "",
      hrs: "2",
      fee: "",
      aliases: [],
      latlong: "11.650035025731679, 75.9824076530733",
      map: "https://www.google.com/maps/place/Karlad+Lake/@11.6507106,75.9817005,17z",

      content:
        "Karlad Lake is believed to have formed after a landslide about two centuries ago. DTPC's adventure camp here offers kayaking, a zipline across the lake, rock climbing, boating, bamboo rafting and nature walks, with life jackets and instructors on site. DTPC says children under 10 are not permitted (it appears to refer to the zipline).",
      amenities: [
        "Mountain View",
        "Private Pool",
        "Yoga Classes",
        "Ayurvedic Spa",
      ],
      tags: [
        "Ghats",
        "kalpetta",
        "Deccan Plateau",
        "seafood",
        "yoga",
        "cliff",
        "ayurvedic",
        "spice shops",
      ],

      type: "Water Falls",
      knowmore: "https://www.bwstays.com/bw-karland-lake-romantic-wayanad.html",

      duration: "1-2 Hours",
      www: "",
    },
    {
      id: 44,
      name: "Pookode Lake",
      description:
        "Natural freshwater lake at 770 m near Vythiri, about 12 km from Kalpetta, shaped roughly like the map of India, with boating.",
      image: [
        "https://www.bwstays.com/assets/img/romantic/bw-vacation-pookode-lake-wayanad.webp",
        "https://www.bwstays.com/assets/img/romantic/bw-vacation-pookode-lake-wayanad.webp",
      ],
      holidays: "NA",
      timing: ["09:00-18:00"],
      Contact: "+91 75938 92951, +91 93872 95184",
      seasontovisit: [
        "Summer (March-May)",
        "Monsoon (June-September)",
        "Winter (October-February)",
      ],
      distance: "13",
      latlong: "11.542442317568533, 76.02721621504702",
      map: "https://www.google.com/maps/place/Pookode+Lake/@11.5424566,76.0272233,17z",
      hrs: "2",
      fee: "Adult INR 40, child INR 30",
      aliases: ["pookode", "pookode lake"],
      transport: "Public",
      rating: "",
      content:
        "Pookode Lake lies at 770 m among forested hills near Vythiri and is said to resemble the map of India in outline. The Panamaram river, a tributary of the Kabini, rises here. Visitors can walk around the lake, hire pedal or row boats, see the aquarium and try the fish spa; tickets are sold at the counter only.",
      amenities: [
        "Mountain View",
        "Private Pool",
        "Yoga Classes",
        "Ayurvedic Spa",
      ],
      tags: [
        "Ghats",
        "kalpetta",
        "Deccan Plateau",
        "seafood",
        "yoga",
        "cliff",
        "ayurvedic",
        "spice shops",
      ],

      type: "Romantic Spots",
      knowmore: "https://www.bwstays.com/bw-pookode-lake-romantic-wayanad.html",

      duration: "1-2 Hours",
      www: "",
    },
    {
      id: 45,
      name: "Banasura Sagar Dam",
      description:
        "Earth dam and reservoir at the foot of the Banasura Hills, about 21 km from Kalpetta, with boating and islands in the reservoir.",
      image: [
        "https://www.bwstays.com/assets/img/romantic/bw-staycation-banasura-sagar-wayanad.webp",
        "https://www.bwstays.com/assets/img/romantic/bw-resort-banasura-sagar-dam-homestay.webp",
        "https://www.bwstays.com/assets/img/romantic/bw-stays-banasura-sagar-dam-wayanad.webp",
      ],
      holidays: "NA",
      timing: ["09:00-17:30"],
      Contact: "+91 493 627 3460",
      seasontovisit: [
        "Summer (March-May)",
        "Monsoon (June-September)",
        "Winter (October-February)",
      ],
      distance: "21",
      latlong: "11.670215394616353, 75.95775654232763",
      map: "https://www.google.com/maps/place/Banasura+Sagar+Dam%2C+Padinjarathara%2C+Kerala+673575/@11.67,75.957778,17z",
      hrs: "1",
      fee: "Adult INR 40, child INR 20",
      aliases: ["banasura", "banasurasagar", "banasura dam"],
      transport: "Public",
      rating: "",
      content:
        "DTPC describes Banasura Sagar as the largest earth dam in India. It is named after Banasura, son of Mahabali, who by local lore did penance on the hills above. The reservoir has small islands formed when land was submerged. Visitors can take speed, pontoon or shikara boats, kayak, ride the zipline or walk in the small park; the Banasura Hill trek also starts nearby.",
      amenities: [
        "Mountain View",
        "Private Pool",
        "Yoga Classes",
        "Ayurvedic Spa",
      ],
      tags: [
        "Ghats",
        "kalpetta",
        "Deccan Plateau",
        "seafood",
        "yoga",
        "cliff",
        "ayurvedic",
        "spice shops",
      ],
      type: "Romantic Spots",
      knowmore:
        "https://www.bwstays.com/bw-banasurasagar-dam-romantic-wayanad.html",
      duration: "1-2 Hours",
      www: "",
    },
    {
      id: 46,
      name: "Mailadippara",
      description:
        "A rocky hill on the eastern edge of Kalpetta, near the Civil Station and the bypass road, climbed on foot for views over the town.",
      image: [
        "https://www.bwstays.com/assets/img/romantic/black-and-white-mailadanpara-wayanad.webp",
      ],
      holidays: "NA",
      timing: [],
      Contact: "",
      seasontovisit: [
        "Summer (March-May)",
        "Monsoon (June-September)",
        "Winter (October-February)",
      ],
      distance: "3",
      latlong: "11.624409556486977, 76.0923043558191",
      map: "https://www.google.com/maps/place/Myladippara/@11.6241626,76.092358,17z",
      transport: "Public",
      rating: "",
      hrs: "2",
      fee: "",
      aliases: [],
      content:
        "Myladippara is a cliff-like hill just east of the Kalpetta Civil Station, next to the national highway bypass. It is reached by a short walk up from the road and is visited for its view over Kalpetta town. No official timing, fee or management body is published for it.",
      amenities: [
        "Mountain View",
        "Private Pool",
        "Yoga Classes",
        "Ayurvedic Spa",
      ],
      tags: [
        "Ghats",
        "kalpetta",
        "Deccan Plateau",
        "seafood",
        "yoga",
        "cliff",
        "ayurvedic",
        "spice shops",
      ],

      type: "Romantic Spots",
      knowmore: "https://www.bwstays.com/bw-mailadippara-romantic-wayanad.html",

      duration: "1-2 Hours",
      www: "",
    },
    {
      id: 47,
      name: "Banasura Sagar Hills",
      description:
        "A Western Ghats hill range above Banasura Sagar Dam, climbed on a guided forest-department trek that needs prior permission.",
      image: [
        "https://www.bwstays.com/assets/img/romantic/bw-villa-home-banasura-hills.webp",
      ],
      holidays: "NA",
      timing: ["07:30-11:00"],
      Contact: "+91 493 629 8399, +91 85476 02722",
      seasontovisit: [
        "Summer (March-May)",
        "Monsoon (June-September)",
        "Winter (October-February)",
      ],
      distance: "29",
      latlong: "11.695175204242553, 75.90797008546211",
      map: "https://www.google.com/maps/place/Banasura+Hill/@11.694167,75.908056,17z",
      hrs: "2",
      fee: "Group of 5 INR 4,000 (INR 650 per extra person); students INR 2,500; foreigners INR 7,000",
      aliases: [],
      transport: "Public",
      rating: "",
      content:
        "DTPC Wayanad gives the hill as about 6,800 ft high, one of the highest ranges in the Western Ghats, with Banasura Sagar Dam at its foot. The trek follows the Meenmutty-Kattukunnu-Aanchola route and needs forest department permission; guides are available at Meenmutty falls. Entry is 07:30-11:00 for up to 75 people, offline booking only, ages 11+.",
      amenities: [
        "Mountain View",
        "Private Pool",
        "Yoga Classes",
        "Ayurvedic Spa",
      ],
      tags: [
        "Ghats",
        "kalpetta",
        "Deccan Plateau",
        "seafood",
        "yoga",
        "cliff",
        "ayurvedic",
        "spice shops",
      ],
      type: "Romantic Spots",
      knowmore:
        "https://www.bwstays.com/bw-banasura-sagar-hills-romantic-wayanad.html",
      duration: "1-2 Hours",
      www: "",
    },
    {
      id: 48,
      name: "Manjappara",
      description:
        "A picturesque waterfall surrounded by lush greenery and coffee plantations.",
      image: [
        "https://www.bwstays.com/assets/img/romantic/bw-holiday-longstay-manjapara-viewpoint.webp",
      ],
      holidays: "NA",
      timing: [],
      Contact: "",
      seasontovisit: [
        "Summer (March-May)",
        "Monsoon (June-September)",
        "Winter (October-February)",
      ],
      distance: "23",
      latlong: "11.602130295485557, 76.19922151534472",
      map: "https://www.google.com/maps/place/Manjappara+View+Point/@11.6115748,76.2020084,17z",
      hrs: "2",
      fee: "",
      aliases: [],
      transport: "Public",
      rating: "",
      content:
        "Relax in our stunning villa overlooking the peaks of Wayanad. Enjoy seafood, yoga sessions, and explore the famous Chembra cliff. Easy access to local spice shops and traditional ayurvedic centers.",
      amenities: [
        "Mountain View",
        "Private Pool",
        "Yoga Classes",
        "Ayurvedic Spa",
      ],
      tags: [
        "Ghats",
        "kalpetta",
        "Deccan Plateau",
        "seafood",
        "yoga",
        "cliff",
        "ayurvedic",
        "spice shops",
      ],

      type: "Romantic Spots",
      knowmore: "https://www.bwstays.com/bw-manjappara-romantic-wayanad.html",

      duration: "1-2 Hours",
      www: "",
    },
    {
      id: 50,
      name: "Phantom rock",
      description:
        "A skull-shaped granite rock formation near Ambalavayal, named after the comic hero the Phantom and reached by a short trek.",
      image: [
        "https://www.bwstays.com/assets/img/romantic/bw-resort-phanthom-rock-wayanad.webp",
      ],
      holidays: "NA",
      timing: [],
      Contact: "",
      seasontovisit: [
        "Summer (March-May)",
        "Monsoon (June-September)",
        "Winter (October-February)",
      ],
      distance: "26",
      latlong: "11.636687345789426, 76.20460141779273",
      map: "https://www.google.com/maps/place/Phantom+Rock/@11.636545,76.204627,17z",
      hrs: "2",
      fee: "",
      aliases: [],
      transport: "Public",
      rating: "",
      content:
        "Phantom Rock is a natural rock outcrop near Ambalavayal whose shape resembles a human skull, which gave it the name of the comic-strip hero the Phantom. The last stretch is on foot along narrow trails; Edakkal Caves and Cheengeri hill are nearby. No official timing or fee is published.",
      amenities: [
        "Mountain View",
        "Private Pool",
        "Yoga Classes",
        "Ayurvedic Spa",
      ],
      tags: [
        "Ghats",
        "kalpetta",
        "Deccan Plateau",
        "seafood",
        "yoga",
        "cliff",
        "ayurvedic",
        "spice shops",
      ],
      type: "Romantic Spots",
      knowmore:
        "https://www.bwstays.com/bw-phanthom-rock-romantic-wayanad.html",
      duration: "1-2 Hours",
      www: "",
    },
    {
      id: 51,
      name: "Kurumbalakotta",
      description:
        "A hill in Kottathara panchayat near Venniyode, about 991 m high, climbed at dawn for views over the Wayanad plateau.",
      image: [
        "https://www.bwstays.com/assets/img/romantic/bw-weekend-kurumbalakotta-wayanad.webp",
      ],
      holidays: "NA",
      timing: [],
      Contact: "",
      seasontovisit: [
        "Summer (March-May)",
        "Monsoon (June-September)",
        "Winter (October-February)",
      ],
      distance: "18",
      latlong: "11.6963813, 76.0342789",
      map: "https://www.google.com/maps/place/Kurumbalakotta+Mala/@11.6968112,76.0344142,17z",
      hrs: "2",
      fee: "",
      aliases: [],
      transport: "Public",
      rating: "",
      content:
        "Kurumbalakkotta is a monolithic hill of about 991 m in Kottathara panchayat, near Venniyode, reached from Kalpetta via Kambalakkad. Kerala Tourism describes a moderate trek through tall grass with no formal path, and the Kurumbalakkotta Bhagavathy temple on the way down. Wikipedia notes a large landslide on the hill in July 2024; check access locally.",
      amenities: [
        "Mountain View",
        "Private Pool",
        "Yoga Classes",
        "Ayurvedic Spa",
      ],
      tags: [
        "Ghats",
        "kalpetta",
        "Deccan Plateau",
        "seafood",
        "yoga",
        "cliff",
        "ayurvedic",
        "spice shops",
      ],

      type: "Romantic Spots",
      knowmore:
        "https://www.bwstays.com/bw-kurumbalakotta-romantic-wayanad.html",

      duration: "1-2 Hours",
      www: "",
    },
    {
      id: 55,
      name: "Neelimala view point",
      description:
        "A hilltop viewpoint near Vaduvanchal, reached by jeep track and a trek, known for its view of Meenmutty falls.",
      image: [
        "https://www.bwstays.com/assets/img/romantic/bw-kalpetta-neelimala-view-point-wayanad.webp",
      ],
      holidays: "NA",
      timing: [],
      Contact: "",
      seasontovisit: [
        "Summer (March-May)",
        "Monsoon (June-September)",
        "Winter (October-February)",
      ],
      distance: "33",
      latlong: "11.5334912, 76.2278983",
      map: "https://www.google.com/maps/place/Neelimala+View+Point/@11.5366314,76.2291179,17z",
      hrs: "2",
      fee: "",
      aliases: [],
      transport: "Public",
      rating: "",
      content:
        "Neelimala, near Vaduvanchal, is named for the blue mist over the hills at dawn. Kerala Tourism describes a jeep ride followed by a trek past coffee plantations, grassland and boulders to a top that looks over Meenmutty falls and the Western Ghats. No official timing or fee is published, and access may be restricted by the forest department.",
      amenities: [
        "Mountain View",
        "Private Pool",
        "Yoga Classes",
        "Ayurvedic Spa",
      ],
      tags: [
        "Ghats",
        "kalpetta",
        "Deccan Plateau",
        "seafood",
        "yoga",
        "cliff",
        "ayurvedic",
        "spice shops",
      ],

      type: "Romantic Spots",
      knowmore:
        "https://www.bwstays.com/bw-neelimala-view-point-romantic-wayanad.html",

      duration: "1-2 Hours",
      www: "",
    },
    {
      id: 58,
      name: "900 Kandi",
      description:
        "An adventure park in the forested 900 Kandi hills near Meppadi, with a glass-floored bridge, zip line, swings and off-road jeep rides.",
      image: [
        "https://www.bwstays.com/assets/img/romantic/bw-weekend-destination-glassbridge-wayanad.webp",
        "https://www.bwstays.com/assets/img/romantic/bw-stays-900-thollayiram-kandi-wayanad.webp",
      ],
      holidays: "NA",
      timing: ["06:30-18:30"],
      Contact: "+91 99474 60835, +91 95264 81745",
      seasontovisit: [
        "Summer (March-May)",
        "Monsoon (June-September)",
        "Winter (October-February)",
      ],
      distance: "26",
      latlong: "11.4967237, 76.1051083",
      map: "https://www.google.com/maps/place/900+kandi+eco+park/@11.502026,76.1104116,17z",
      transport: "Public",
      rating: "",
      hrs: "3",
      fee: "Adult INR 250, child INR 100; zip line INR 350, zip cycling INR 250, adventure swing INR 100",
      aliases: ["900 kandi", "thollayiram kandi", "glass bridge"],
      content:
        "DTPC lists Skypark at 900 Kandi as an eco-friendly adventure park set in forest and hills, with glass bridge walks, ziplining, tree-top trails, light trekking and off-road jeep rides. Entry is INR 250 for adults and INR 100 for children, with separate charges for the zip line, zip cycling, swing and rifle shooting. Bookings are offline only.",
      amenities: ["Mountain View", "Glass Bridge", "Yoga Classes", "Park"],
      tags: [
        "Ghats",
        "kalpetta",
        "Deccan Plateau",
        "seafood",
        "yoga",
        "cliff",
        "ayurvedic",
        "spice shops",
      ],
      type: "Romantic Spots",
      knowmore: "https://www.bwstays.com/bw-900-kandi-romantic-wayanad.html",

      duration: "1-2 Hours",
      www: "",
    },
    {
      id: 83,
      name: "Neelarchalu",
      description: "Tribal village between Ambalavayal and Meppadi, surrounded on three sides by the Karapuzha reservoir, with a sunset viewpoint over the water.",
      image: [
        "https://www.bwstays.com/assets/img/romantic/black-and-white-nellarachal-wayanad.webp",
      ],
      holidays: "NA",
      timing: [],
      Contact: "",
      seasontovisit: [
        "Summer (March-May)",
        "Monsoon (June-September)",
        "Winter (October-February)",
      ],
      distance: "23",
      latlong: "11.60151625745816, 76.17700752883617",
      map: "https://www.google.com/maps/place/Nellarachal/@11.6012903,76.1769968,17z",
      transport: "Public",
      rating: "",
      hrs: "2",
      fee: "",
      aliases: [],
      content:
        "Nellarachal sits within the Karapuzha Dam reservoir, which curves around it on three sides; the name likely comes from nellu (paddy), as parts of the reservoir were paddy fields. The Karapuzha viewpoint has bamboo seating facing the water for sunset. Local hosts arrange village experiences such as visits to Kurichya homes; Edakkal Caves is about 10 km away.",
      amenities: [
        "Mountain View",
        "Private Pool",
        "Yoga Classes",
        "Ayurvedic Spa",
      ],
      tags: [
        "Ghats",
        "kalpetta",
        "Deccan Plateau",
        "seafood",
        "yoga",
        "cliff",
        "ayurvedic",
        "spice shops",
      ],

      type: "Romantic Spots",
      knowmore:
        "https://www.bwstays.com/bw-neelarchalu-lake-romantic-wayanad.html",

      duration: "1-2 Hours",
      www: "",
    },
    {
      id: 84,
      name: "Munneswaran Kunnu",
      description: "Grassy hilltop near Thalappuzha in Mananthavady taluk, reached by a steep walk from Makkimala, with a small Shiva shrine on top.",
      image: [
        "https://www.bwstays.com/assets/img/romantic/bw-villa-holiday-munnewaram-hill.webp",
      ],
      holidays: "NA",
      timing: [],
      Contact: "",
      seasontovisit: [
        "Summer (March-May)",
        "Monsoon (June-September)",
        "Winter (October-February)",
      ],
      distance: "42",
      latlong: "11.863748932136927, 75.9589761534138",
      map: "https://www.google.com/maps/place/Muneeswaran+Kunnu+View+Point/@11.8635547,75.9589547,17z",
      transport: "Public",
      rating: "",
      hrs: "2",
      fee: "",
      aliases: [],
      content:
        "The track to the top starts at the Makkimala tribal settlement, about 5 km from Thalappuzha town, and ends with a steep climb of roughly 500 m over grassland. The summit, around 950 to 1,000 m high, has a small Shiva shrine and views over north-eastern Wayanad; it is often called the 'Vagamon of Wayanad'.",
      amenities: [
        "Mountain View",
        "Private Pool",
        "Yoga Classes",
        "Ayurvedic Spa",
      ],
      tags: [
        "Ghats",
        "kalpetta",
        "Deccan Plateau",
        "seafood",
        "yoga",
        "cliff",
        "ayurvedic",
        "spice shops",
      ],

      type: "Romantic Spots",
      knowmore:
        "https://www.bwstays.com/bw-munneswaran-kunnu-romantic-wayanad.html",

      duration: "1-2 Hours",
      www: "",
    },
    {
      id: 85,
      name: "Bamboo Forest Valentine's Park",
      description:
        "A small privately run park among bamboo groves in the Nadavayal area of Wayanad, about 21 km from Kalpetta, for a quiet walk in the shade. Opening hours and fees are not confirmed: call before you go.",
      image: [
        "https://www.bwstays.com/assets/img/romantic/bw-workation-bamboo-park-wayanad.webp",
      ],
      holidays: "NA",
      timing: [],
      Contact: "+91-7591933369",
      seasontovisit: [
        "Summer (March-May)",
        "Monsoon (June-September)",
        "Winter (October-February)",
      ],
      distance: "21",
      latlong: "11.743355206702713, 76.12590988793323",
      map: "https://www.google.com/maps/place/Bamboo+Forest+Valentine's+Park/@11.7413864,76.1261019,17z",
      transport: "Public",
      rating: "",
      hrs: "2",
      fee: "",
      aliases: [],
      content:
        "Relax in our stunning villa overlooking the peaks of Wayanad. Enjoy seafood, yoga sessions, and explore the famous Chembra cliff. Easy access to local spice shops and traditional ayurvedic centers.",
      amenities: [
        "Mountain View",
        "Private Pool",
        "Yoga Classes",
        "Ayurvedic Spa",
      ],
      tags: [
        "Ghats",
        "kalpetta",
        "Deccan Plateau",
        "seafood",
        "yoga",
        "cliff",
        "ayurvedic",
        "spice shops",
      ],

      type: "Romantic Spots",
      knowmore:
        "https://www.bwstays.com/bw-bamboo-forest-valentine-park-wayanad.html",
      duration: "1-2 Hours",
      www: "",
    },

  ],

  culthist: [
    {
      id: 6,
      name: "Sultan's Bathery Valmiki Ashram",
      description:
        "Simple thatched hermitage near Pulpally that local tradition links to Sage Valmiki and to Sita's stay in the forest.",
      image: [
        "https://www.bwstays.com/assets/img/heritage/bw-stays-valmiki-ashramam-tourist.webp",
      ],
      holidays: "NA",
      timing: [],
      map: "https://www.google.com/maps/place/Valmiki+Ashramam+Munippara/@11.7787456,76.1955915,17z",
      Contact: "",
      seasontovisit: [
        "Summer (March-May)",
        "Monsoon (June-September)",
        "Winter (October-February)",
      ],
      distance: "32",
      transport: "Public",
      rating: "",
      latlong: "11.778971412702218, 76.19547348280202",
      map: "https://www.google.com/maps/place/Valmiki+Ashramam+Munippara/@11.7787456,76.1955915,17z",
      hrs: "2",
      fee: "",
      aliases: [],
      content:
        "Local belief holds that Sage Valmiki sheltered Sita here and that Lava and Kusa were born here. The site, at Ashramamkolli in Amarakuni on the Pulpally route, is a thatched hut with mud walls that Nayaka tribal families rebuild each year; visitors come to pray and meditate. It ties in with the Seetha Devi Lava Kusa temple at Pulpally.",
      amenities: [
        "Air Conditioning",
        "Gourmet Kitchen",
        "Boat Rides",
        "Spice Garden Tour",
      ],
      tags: [
        "heritage",
        "mountains",
        "traditional",
        "kerala",
        "cuisine",
        "spice",
        "quiet",
        "relaxed",
      ],

      type: "Cultural & Historical",
      knowmore:
        "https://www.bwstays.com/bw-sultan-batthery-valmiki-ashram-heritage-wayanad.html",

      duration: "1-2 Hours",
      www: "",
    },
    {
      id: 24,
      name: "Mananthavady Pazhassi Tomb",
      description:
        "Memorial and museum at Mananthavady on the Kabani riverbank, where Pazhassi Raja was cremated in 1805.",
      image: [
        "https://www.bwstays.com/assets/img/heritage/bw-stays-pazhassi-tomb-wayanad-resort.webp",
        "https://www.bwstays.com/assets/img/heritage/bw-workation-pazhassi-tomb-wayanad.webp",
      ],
      holidays: "Mon",
      timing: ["09:00-17:30"],
      Contact: "+91 75938 92958",
      seasontovisit: [
        "Summer (March-May)",
        "Monsoon (June-September)",
        "Winter (October-February)",
      ],
      distance: "30",
      transport: "Public",
      latlong: "11.8013942, 76.0006489",
      map: "https://www.google.com/maps/place/Pazhassi+Raja+Tomb/@11.8013852,76.0006523,17z",
      rating: "",
      hrs: "2",
      fee: "Adult INR 30, child INR 20",
      aliases: [],
      content:
        "Pazhassi Raja, ruler of the former Kottayam kingdom, fought the East India Company from 1793 until his death in 1805 and was cremated here. The tomb was turned into a museum in 1996 and holds relics linked to him, including a sword. The Kerala State Archaeology Department manages the site. Tickets are sold at the counter only.",
      amenities: [
        "Air Conditioning",
        "Gourmet Kitchen",
        "Boat Rides",
        "Spice Garden Tour",
      ],
      tags: [
        "heritage",
        "mountains",
        "traditional",
        "kerala",
        "cuisine",
        "spice",
        "quiet",
        "relaxed",
      ],

      type: "Cultural & Historical",
      knowmore:
        "https://www.bwstays.com/bw-mananthavady-pazhassi-tomb-heritage-wayanad.html",

      duration: "1-2 Hours",
      www: "",
    },
    {
      id: 25,
      name: "Chain Tree",
      description:
        "Ficus tree with a chain around it beside the highway at Lakkidi, tied to the folk legend of the tribal guide Karinthandan.",
      image: [
        "https://www.bwstays.com/assets/img/heritage/bw-stays-chain-tree-service-apartment.webp",
        "https://www.bwstays.com/assets/img/heritage/bw-stays-chain-tree-wayanad-homestay.webp",
      ],
      holidays: "NA",
      timing: [],
      Contact: "",
      seasontovisit: [
        "Summer (March-May)",
        "Monsoon (June-September)",
        "Winter (October-February)",
      ],
      distance: "15",
      transport: "Public",
      latlong: "11.519302998311304, 76.02092845767235",
      map: "https://www.google.com/maps/place/Karinthandan+Temple/@11.519098,76.020907,17z",
      rating: "",
      hrs: "2",
      fee: "No entry fee",
      aliases: [],
      content:
        "Local legend says a tribal youth, Karinthandan, showed a British engineer the route up the ghat into Wayanad and was then killed so the engineer could take the credit; his restless spirit was later said to be chained to this tree by a priest. A small shrine is kept at the tree. It stands by the road at Lakkidi, about 15 km from Kalpetta; entry is free.",
      amenities: [
        "Air Conditioning",
        "Gourmet Kitchen",
        "Boat Rides",
        "Spice Garden Tour",
      ],
      tags: [
        "heritage",
        "mountains",
        "traditional",
        "kerala",
        "cuisine",
        "spice",
        "quiet",
        "relaxed",
      ],

      type: "Cultural & Historical",
      knowmore:
        "https://www.bwstays.com/bw-chain-tree-cultural-heritage-wayanad.html",

      duration: "1-2 Hours",
      www: "",
    },
  ],

  trucking: [
    {
      id: 15,
      name: "Kuruwa Deep",
      description:
        "950-acre protected river delta of forested islets in the east-flowing Kabani river, reached by raft.",
      image: [
        "https://www.bwstays.com/assets/img/trucking/bw-kuruva-island-wayanad-2.webp",
        "https://www.bwstays.com/assets/img/trucking/bw-kuruva-island-wayanad.webp",
      ],
      holidays: "NA",
      timing: ["09:00-15:30"],
      Contact: "+91 75938 92956",
      seasontovisit: [
        "Summer (March-May)",
        "Monsoon (June-September)",
        "Winter (October-February)",
      ],
      distance: "40",
      transport: "Public",
      latlong: "11.821667, 76.092222",
      map: "https://www.google.com/maps/place/Kuruvadweep/@11.821667,76.092222,17z",
      rating: "",
      hrs: "2",
      fee: "Adult INR 220, student INR 100 (foreigner INR 440)",
      aliases: [],
      content:
        "Kuruva is a protected cluster of islands in the Kabani river. Visitor entry is capped at 488 people per day, tickets are sold offline only, and rafting, kayaking and paddling are offered inside. Entry 09:00-15:30, activities to 16:30.",
      amenities: [
        "physical exertion",
        "hiking",
        "Remote Access",
        "Quiet Operation",
      ],
      tags: [
        "HillStation Vibes",
        "OffRoad Adventure",
        "Camping Life",
        "Forest Trails",
        "RoadTrip Vibes",
        "Adventure Tourism",
      ],
      type: "Trekking",
      knowmore: "https://www.bwstays.com/bw-kuruwa-deep-trucking-wayanad.html",

      duration: "1-2 Hours",
      www: "",
    },
    {
      id: 17,
      name: "Brahmagiri",
      description:
        "Guided forest trek of about 10 km from the Thirunelli forest camp to the Brahmagiri summit, about 1,608 m, on the Kerala-Karnataka border.",
      image: [
        "https://www.bwstays.com/assets/img/trucking/bw-service-villa-brahmagiri-hills-wayanad.webp",
      ],
      holidays: "NA",
      timing: ["07:30-09:30"],
      Contact: "+91 85476 02511, +91 85476 02506",
      seasontovisit: [
        "Summer (March-May)",
        "Monsoon (June-September)",
        "Winter (October-February)",
      ],
      distance: "50",
      transport: "Public",
      latlong: "11.93289290225645, 75.9940526",
      map: "https://www.google.com/maps/place/Brahmagiri/@11.9322003,75.9940526,17z",
      rating: "",
      hrs: "2",
      fee: "Group of 5 INR 3,500 incl. guide (INR 700 per extra person); single adult INR 1,300 incl. guide; foreigners INR 7,000 for 5",
      aliases: [],
      content:
        "The Brahmagiri hills lie between Wayanad and Kodagu. The guided trek starts at the forest department camp at Thirunelli and takes a little over 3 hours to the summit, through forest with small waterfalls and wildlife. Morning slots only; students must be over 15. The Thirunelli temple stands on the lower slope.",
      amenities: [
        "physical exertion",
        "hiking",
        "Remote Access",
        "Quiet Operation",
      ],
      tags: [
        "HillStation Vibes",
        "OffRoad Adventure",
        "Camping Life",
        "Forest Trails",
        "RoadTrip Vibes",
        "Adventure Tourism",
      ],
      type: "Trekking",
      knowmore: "https://www.bwstays.com/bw-brahmagiri-trucking-wayanad.html",

      duration: "1-2 Hours",
      www: "",
    },
    {
      id: 18,
      name: "Chembra Peak",
      description:
        "Wayanad's highest peak, about 2,100 m, near Meppadi; the guided trail passes a heart-shaped lake, Hridaya Thadakam.",
      image: [
        "https://www.bwstays.com/assets/img/trucking/bw-destination-chembra-wayanad.webp",
        "https://www.bwstays.com/assets/img/trucking/bw-homestay-chembra-wayanad.webp",
      ],
      holidays: "NA",
      timing: ["07:00-15:00"],
      Contact: "+91 493 628 2001",
      seasontovisit: [
        "Summer (March-May)",
        "Monsoon (June-September)",
        "Winter (October-February)",
      ],
      distance: "17",
      transport: "Public",
      latlong: "11.5563005, 76.0832491",
      map: "https://www.google.com/maps/place/Chembra+Peak/@11.5532988,76.0879402,17z",
      rating: "",
      hrs: "3",
      fee: "Entry INR 50 (foreigner INR 80); guided trek INR 4,000 for up to 5 people, INR 800 per extra person",
      aliases: ["chembra", "chembra peak", "chembra trek"],
      content:
        "Chembra rises about 2,100 m above sea level south of Kalpetta near Meppadi. The trail passes the heart-shaped Hridaya Thadakam lake. Treks are guided and need forest-department permission, are limited to 88 people, and the upper half of the route is restricted because of wildlife.",
      amenities: [
        "physical exertion",
        "hiking",
        "Remote Access",
        "Quiet Operation",
      ],
      tags: [
        "HillStation Vibes",
        "OffRoad Adventure",
        "Camping Life",
        "Forest Trails",
        "RoadTrip Vibes",
        "Adventure Tourism",
      ],
      type: "Trekking",
      knowmore: "https://www.bwstays.com/bw-chembra-peak-trucking-wayanad.html",

      duration: "1-2 Hours",
      www: "",
    },
    {
      id: 19,
      name: "Cheengeri Hill",
      description: "Open rocky hill near Ambalavayal run by DTPC as a trekking spot, with views over the Karapuzha river and reservoir.",
      image: [
        "https://www.bwstays.com/assets/img/trucking/bw-weekend-destination-cheengeri-hills.webp",
      ],
      holidays: "NA",
      timing: [],
      Contact: "",
      seasontovisit: [
        "Summer (March-May)",
        "Monsoon (June-September)",
        "Winter (October-February)",
      ],
      distance: "20",
      transport: "Public",
      latlong: "11.619354812785145, 76.19931730771042",
      map: "https://www.google.com/maps/place/Cheengeri+Mala+Trekking/@11.6191686,76.1992997,17z",
      rating: "",
      hrs: "2",
      fee: "",
      aliases: [],
      content:
        "Cheengeri is a gently sloping hill with little forest cover, about 2 km from Ambalavayal on the road from Sultan Bathery to Kaduvakuzhi. DTPC runs it as an authorised trekking and camping spot with ropes on the rocky upper section; mornings are recommended. It is open through the year.",
      amenities: [
        "physical exertion",
        "hiking",
        "Remote Access",
        "Quiet Operation",
      ],
      tags: [
        "HillStation Vibes",
        "OffRoad Adventure",
        "Camping Life",
        "Forest Trails",
        "RoadTrip Vibes",
        "Adventure Tourism",
      ],
      type: "Trekking",
      knowmore:
        "https://www.bwstays.com/bw-cheengeri-hill-trucking-wayanad.html",

      duration: "1-2 Hours",
      www: "",
    },
    {
      id: 20,
      name: "Lakkidi Ghats View Point",
      description:
        "Roadside viewpoint at the top of the Thamarassery ghat pass, about 700 m up and 5 km from Vythiri, overlooking the hairpin bends.",
      image: [
        "https://www.bwstays.com/assets/img/romantic/bw-stays-ghats-viewpoint-wayanad.webp",
        "https://www.bwstays.com/assets/img/romantic/bw-vacation-ghats-viewpoint-kalpetta.webp",
        "https://www.bwstays.com/assets/img/romantic/bw-villa-rooms-ghats-wayanad.webp",
        "https://www.bwstays.com/assets/img/romantic/bw-stays-ghats-wayanad.webp",
      ],
      holidays: "NA",
      timing: [],
      Contact: "",
      seasontovisit: [
        "Summer (March-May)",
        "Monsoon (June-September)",
        "Winter (October-February)",
      ],
      distance: "16",
      transport: "Public",
      latlong: "11.512393990351887, 76.01895535767235",
      map: "https://www.google.com/maps/place/Lakkidi+View+Point/@11.5121995,76.0189339,17z",
      rating: "",
      hrs: "2",
      fee: "",
      aliases: [],
      content:
        "Lakkidi sits at about 700 m (2,296 ft) at the crest of the Thamarassery ghat and is known as the gateway of Wayanad. The view looks down over the hairpin road and valley towards Kozhikode. The Chain Tree, linked to the legend of the tribal guide Karinthandan, is nearby. It is a roadside stop with no ticket listed.",
      amenities: [
        "physical exertion",
        "hiking",
        "Remote Access",
        "Quiet Operation",
      ],
      tags: [
        "HillStation Vibes",
        "OffRoad Adventure",
        "Camping Life",
        "Forest Trails",
        "RoadTrip Vibes",
        "Adventure Tourism",
      ],
      type: "Trekking",
      knowmore:
        "https://www.bwstays.com/bw-lakkidi-ghats-view-point-wayanad.html",

      duration: "1-2 Hours",
      www: "",
    },
    {
      id: 21,
      name: "Edakkal Caves",
      description:
        "Natural rock caves on Ambukuthi hills, 10 km from Sultan Bathery, with ancient engravings of human figures and animals.",
      image: [
        "https://www.bwstays.com/assets/img/trucking/bw-staycation-edakkal-caves-wayanad.webp",
        "https://www.bwstays.com/assets/img/trucking/bw-homestay-kerala-wayanad-edakkal-caves.webp",
      ],
      holidays: "Mon",
      timing: ["08:30-16:00"],
      Contact: "+91 493 621 5339, +91 94466 02134, +91 94460 52134",
      seasontovisit: [
        "Summer (November-March)",
      ],
      distance: "28",
      transport: "Public",
      latlong: "11.6268407, 76.234269",
      map: "https://www.google.com/maps/place/Edakkal+Caves/@11.6268407,76.234269,17z",
      rating: "",
      hrs: "4",
      fee: "Adult INR 50, child INR 30",
      aliases: ["edakkal", "edakkal caves", "cave"],
      content:
        "The caves are two natural rock formations about 1,200 ft up the Ambukuthi hills, formed by a split in a huge rock and found in 1895. Their walls carry ancient engravings and scripts, and the site was occupied several times, the oldest phase dating to the Stone Age. A steep climb leads up; daily visitors are capped at 1,920.",
      amenities: [
        "physical exertion",
        "hiking",
        "Remote Access",
        "Quiet Operation",
      ],
      tags: [
        "HillStation Vibes",
        "OffRoad Adventure",
        "Camping Life",
        "Forest Trails",
        "RoadTrip Vibes",
        "Adventure Tourism",
      ],
      type: "Trekking",
      knowmore:
        "https://www.bwstays.com/bw-edakkal-caves-trucking-wayanad.html",

      duration: "2-3 Hours",
      www: "",
    },
    {
      id: 87,
      name: "Kolagapara",
      description: "Hill with a large monolithic rock about 5.5 km from Meenangadi, climbed on a steep 2 km trail through forest patches and tea gardens.",
      image: [
        "https://www.bwstays.com/assets/img/trucking/bw-service-villa-kolagappara-wayanad.webp",
      ],
      holidays: "NA",
      timing: ["06:00-18:00"],
      Contact: "",
      seasontovisit: [
        "Summer (March-May)",
        "Monsoon (June-September)",
        "Winter (October-February)",
      ],
      distance: "15",
      transport: "Public",
      rating: "",
      hrs: "2",
      fee: "No entry fee",
      aliases: [],
      latlong: "11.656161744533218, 76.19452691872974",
      map: "https://www.google.com/maps/place/Kolagappara/@11.6507437,76.191415,17z",
      content:
        "The roughly 2 km climb to the top is steep in places and passes forest patches and tea plantations rich in plants and birds. The summit gives views of the surrounding hills and, on clear days, Krishnagiri cricket stadium. Local buses run from Meenangadi and Sulthan Bathery; DTPC Kalpetta can arrange guided visits to nearby tribal settlements.",
      amenities: [
        "physical exertion",
        "hiking",
        "Remote Access",
        "Quiet Operation",
      ],
      tags: [
        "HillStation Vibes",
        "OffRoad Adventure",
        "Camping Life",
        "Forest Trails",
        "RoadTrip Vibes",
        "Adventure Tourism",
      ],
      type: "Trekking",
      knowmore: "https://www.bwstays.com/bw-kolagapara-trucking-wayanad.html",

      duration: "1-2 Hours",
      www: "",
    },
  ],

  wildlife: [
    {
      id: 28,
      name: "Muthanga Wildlife Sanctuary",
      description:
        "Southern part of Wayanad Wildlife Sanctuary near Sulthan Bathery, visited by Forest Department jeep and bus safaris.",
      image: [
        "https://www.bwstays.com/assets/img/wildlife/bw-food-stay-muthanga-wildlife-wayanad.webp",
      ],
      holidays: "NA",
      timing: ["06:00-10:00","15:00-18:00"],
      Contact: "+91 99472 71015",
      seasontovisit: [
        "Summer (March-May)",
        "Monsoon (June-September)",
        "Winter (October-February)",
      ],
      distance: "38",
      transport: "Public",
      latlong: "11.671820900367546, 76.3688581955536",
      map: "https://www.google.com/maps/place/Muthanga+Wildlife+Santuary/@11.6715785,76.3687811,17z",
      rating: "",
      hrs: "2",
      fee: "Bus safari INR 350 adult, INR 175 child/student, INR 700 foreigner; jeep INR 2,100 for 4",
      aliases: [],

      content:
        "Wayanad Wildlife Sanctuary (344 sq km, declared 1973) is in two separate blocks; Muthanga is the southern one, adjoining Bandipur (Karnataka) and Mudumalai (Tamil Nadu), and is part of Project Elephant. Elephants, gaur, deer, langurs and occasionally tigers are seen. Visitors may enter only the outer tourism zone on Forest Department safaris; jeeps are hired at the gate and seats are limited per slot.",
      amenities: [
        "Wildlife Viewing",
        "Spice Plantations",
        "Boat Rides",
        "Nature Trails",
      ],
      tags: [
        "Bandipur",
        "wildlife",
        "sanctuary",
        "elephants",
        "tigers",
        "birds",
        "Muthanga",
        "nature",
        "adventure",
      ],
      type: "Wildlife",
      knowmore:
        "https://www.bwstays.com/bw-muthanga-wildlife-sanctuary-wayanad.html",

      duration: "1-2 Hours",
      www: "",
    },
    {
      id: 29,
      name: "Nagarhole wild life sanctuary",
      description:
        "Tiger reserve in Karnataka next to Wayanad's Tholpetty sanctuary, with Forest Department safaris from the Kabini, Veeranahosahalli and Nanachi gates.",
      image: [
        "https://www.bwstays.com/assets/img/wildlife/bw-homestays-nagarhole-wayanad-wildlife-sanctuary.webp",
      ],
      holidays: "NA",
      timing: [],
      Contact: "",
      seasontovisit: [
        "Summer (March-May)",
        "Monsoon (June-September)",
        "Winter (October-February)",
      ],
      distance: "52",
      transport: "Public",
      latlong: "11.99814346014371, 76.0667218165248",
      map: "https://www.google.com/maps/place/Nagarahole+national+park+Safari/@11.9922612,76.0667218,17z",
      rating: "",
      hrs: "2",
      fee: "",
      aliases: [],
      content:
        "Nagarahole adjoins the Tholpetty block of Wayanad Wildlife Sanctuary in the north of the district. The Karnataka Forest Department runs bus, jeep and boat safaris from several gates, including Kakanakote on the Kabini backwaters and Nanachi in Kodagu. Safari times and fares were revised from June 2025; check them before travelling.",
      amenities: [
        "Wildlife Viewing",
        "Spice Plantations",
        "Boat Rides",
        "Nature Trails",
      ],
      tags: [
        "Nagarhole",
        "wildlife",
        "sanctuary",
        "elephants",
        "tigers",
        "birds",
        "spice plantations",
        "nature",
        "adventure",
      ],

      type: "Wildlife",
      knowmore:
        "https://www.bwstays.com/bw-nagarhole-wildlife-sanctuary-wayanad.html",

      duration: "1-2 Hours",
      www: "",
    },
    {
      id: 30,
      name: "Pakshipathalam",
      description:
        "Boulder caves at about 1,740 m in the Brahmagiri Hills, reached on foot from Thirunelli and known for a large bird colony.",
      image: [
        "https://www.bwstays.com/assets/img/wildlife/bw-weekday-pakshipathalam-bird-sanctuary-wayanad.webp",
        "https://www.bwstays.com/assets/img/wildlife/bw-villas-pakshipathalam-wayanad.webp",
      ],
      holidays: "NA",
      timing: [],
      Contact: "",
      seasontovisit: [
        "Summer (March-May)",
        "Monsoon (June-September)",
        "Winter (October-February)",
      ],
      distance: "42",
      transport: "Public",
      latlong: "11.938242187351989, 75.96156549814673",
      map: "https://www.google.com/maps/place/Pakshipathalam/@11.9380375,75.9616406,17z",
      rating: "",
      hrs: "2",
      fee: "",
      aliases: [],
      content:
        "Pakshipathalam is reached only on foot from Thirunelli, a trek of about 3-4 hours each way through deciduous forest, streams and rocky stretches. The caves hold a large bird colony, including the Edible Nest Swiftlet, and gaur, elephants and Malabar giant squirrels live around it. Local lore links the caves to Garuda and the Pandavas. Prior permission from the Forest Department is needed.",
      amenities: [
        "Wildlife Viewing",
        "Spice Plantations",
        "Boat Rides",
        "Nature Trails",
      ],
      tags: [
        "Pakshipathalam",
        "wildlife",
        "sanctuary",
        "elephants",
        "tigers",
        "birds",
        "spice plantations",
        "nature",
        "adventure",
      ],
      type: "Wildlife",
      knowmore:
        "https://www.bwstays.com/bw-pakshipathalam-wildlife-sanctuary-wayanad.html",

      duration: "1-2 Hours",
      www: "",
    },
    {
      id: 31,
      name: "Tholpetty wild life sanctuary",
      description:
        "Northern block of Wayanad Wildlife Sanctuary, east of Mananthavady near Thirunelli, visited on Forest Department jeep safaris.",
      image: [
        "https://www.bwstays.com/assets/img/wildlife/bw-team-event-tholpetty-wildlife-sanctuary-wayanad.webp",
      ],
      holidays: "NA",
      timing: ["06:00-10:00","15:00-18:00"],
      Contact: "+91 493 525 0853, +91 79075 43321, +91 99462 50853",
      seasontovisit: [
        "Summer (March-May)",
        "Monsoon (June-September)",
        "Winter (October-February)",
      ],
      distance: "54.5",
      transport: "Public",
      latlong: "11.9516864, 76.0599344",
      map: "https://www.google.com/maps/place/Tholpetty+Range+-+Wayanad+Wildlife+Sanctuary/@11.944135,76.0648063,17z",
      rating: "",
      hrs: "2",
      fee: "Jeep safari INR 2,100 for 4, INR 2,410 for 5, INR 2,725 for 6; foreigners INR 4,200-4,800",
      aliases: [],
      content:
        "Tholpetty is the northern of the two blocks of Wayanad Wildlife Sanctuary and borders Nagarahole in Karnataka. Forest Department jeep safaris in the outer tourist zone may show elephants, gaur, deer, langurs and, rarely, tigers, leopards and bears. Jeeps are booked at the counter (offline only).",
      amenities: [
        "Wildlife Viewing",
        "Spice Plantations",
        "Boat Rides",
        "Nature Trails",
      ],
      tags: [
        "Tholpetty",
        "wildlife",
        "sanctuary",
        "elephants",
        "tigers",
        "birds",
        "spice plantations",
        "nature",
        "adventure",
      ],
      type: "Wildlife",
      knowmore:
        "https://www.bwstays.com/bw-tholpetty-wildlife-sanctuary-wayanad.html",

      duration: "1-2 Hours",
      www: "",
    },

    {
      id: 32,
      name: "Begur Forest Range",
      description:
        "A forest range of the North Wayanad Forest Division near Mananthavady and Tholpetty; it is not a separate wildlife sanctuary.",
      image: [
        "https://www.bwstays.com/assets/img/wildlife/bw-kerala-begur-wildlife-sanctuary-wayanad.webp",
      ],
      holidays: "NA",
      timing: [],
      Contact: "",
      seasontovisit: [
        "Summer (March-May)",
        "Monsoon (June-September)",
        "Winter (October-February)",
      ],
      distance: "37",
      transport: "Public",
      latlong: "11.84916385461648, 76.08839341349146",
      map: "https://www.google.com/maps/place/Begur+reserve+forest+road/@11.8489486,76.0884256,17z",
      rating: "",
      hrs: "2",
      fee: "",
      aliases: [],
      content:
        "Begur is a forest range of the North Wayanad Forest Division, along the Mananthavady-Tholpetty side of northern Wayanad. It is not one of the ranges of the Wayanad Wildlife Sanctuary, and no visiting programme, timings, fees or contact are published officially; ask the Kerala Forest Department before planning a visit.",
      amenities: [
        "Wildlife Viewing",
        "Spice Plantations",
        "Boat Rides",
        "Nature Trails",
      ],
      tags: [
        "Begur",
        "wildlife",
        "sanctuary",
        "elephants",
        "tigers",
        "birds",
        "spice plantations",
        "nature",
        "adventure",
      ],
      type: "Wildlife",
      knowmore:
        "https://www.bwstays.com/bw-begur-wildlife-sanctuary-wayanad.html",

      duration: "1-2 Hours",
      www: "",
    },
  ],
  farms: [
    {
      id: 88,
      name: "Gurukula Botanical Sanctuary",
      description:
        "Conservation garden near Periya in northern Wayanad, founded in 1981, that grows and restores native plants of the Western Ghats.",
      image: [
        "https://www.bwstays.com/assets/img/farm/bw-gurukula-botanical-sanctuary-wayanad.webp",
      ],
      holidays: "Sun",
      timing: ["09:00-16:00"],
      Contact: "+91 702 509 7426",
      seasontovisit: ["All Season"],
      distance: "57",
      transport: "Public",
      latlong: "11.8227559, 75.8486584",
      map: "https://www.google.com/maps?q=11.821216,75.844855",
      rating: "",
      hrs: "2",
      fee: "",
      aliases: [],
      content:
        "Founded by Wolfgang Theuerkauf in 1981 at the edge of a rainforest reserve, the sanctuary grows rare and threatened Western Ghats plants, among them ferns, mosses, balsams, orchids, aroids and gingers, and reintroduces them into the wild. Botanical day tours are offered Monday to Saturday in several languages, including English and Malayalam.",
      amenities: ["agritourism", "educational", "recreational", "working farm"],
      tags: [
        "Family Farm Day",
        "Agri Education",
        "Farm Fun",
        "Eco Tourism",
        "Educational Farm",
        "HandsOnLearning",
      ],

      type: "Farm Visit",
      knowmore: "https://www.bwstays.com/bw-gurukula-botanical-sanctuary-wayanad.html",

      duration: "1-2 Hours",
      www: "",
    },

    {
      id: 64,
      name: "Ambalavayal",
      description:
        "Kerala Agricultural University's research station at Ambalavayal, with a nursery open to visitors and the annual Pooppoli flower show.",
      image: [
        "https://www.bwstays.com/assets/img/farm/bw-stays-rars-wayanad-ambalavayal.webp",
      ],
      holidays: "NA",
      timing: [],
      Contact: "+91 4936 260421",
      seasontovisit: ["All Season"],
      distance: "21",
      transport: "Public",
      latlong: "11.616591290587456, 76.21447474945045",
      map: "https://www.google.com/maps/place/RARS+Ambalavayal/@11.6157899,76.214236,17z",
      rating: "",
      hrs: "2",
      fee: "",
      aliases: [],
      content:
        "The farm was set up by the Madras government in 1945 under the post-war Wayanad colonisation scheme, became a horticultural research station in 1966 and passed to Kerala Agricultural University after 1972. Tourists may visit its nursery of roses and ornamental plants and buy planting material. It hosts the Pooppoli flower festival around January.",
      amenities: ["agritourism", "educational", "recreational", "working farm"],
      tags: [
        "Family Farm Day",
        "Agri Education",
        "Farm Fun",
        "Eco Tourism",
        "Educational Farm",
        "HandsOnLearning",
      ],
      type: "Farm Visit",
      knowmore: "https://www.bwstays.com/bw-ambalavayal-farm-rars-wayanad.html",
      duration: "1-2 Hours",
      www: "",
    },
    {
      id: 63,
      name: "Boys Town",
      description: "A campus about 13 km from Mananthavady where the Wayanad Social Service Society runs a herbal garden, gene park and farm units.",
      image: [
        "https://www.bwstays.com/assets/img/farm/bw-stays-boys-town-farm-wayanad.webp",
      ],
      holidays: "NA",
      timing: [],
      Contact: "+91-444 444 4444",
      seasontovisit: ["All Season"],
      distance: "43",
      transport: "Public",
      latlong: "11.842370909585952, 75.92226125826711",
      map: "https://www.google.com/maps/place/Boys+Town%2C+Kerala/@11.8401763,75.9187422,17z",
      rating: "",
      hrs: "2",
      fee: "",
      aliases: [],
      content:
        "At Boys Town near Thalappuzha, the Wayanad Social Service Society (founded 1974) runs a herbal garden, a nature care centre, a sericulture unit and a permaculture centre. Its Gene Park for medicinal plants grew out of an Indo-Danish project. No visiting hours or fee are published by an official source.",
      amenities: ["agritourism", "educational", "recreational", "working farm"],
      tags: [
        "Family Farm Day",
        "Agri Education",
        "Farm Fun",
        "Eco Tourism",
        "Educational Farm",
        "HandsOnLearning",
      ],
      type: "Farm Visit",
      knowmore: "https://www.bwstays.com/bw-boys-town-farm-wayanad.html",

      duration: "1-2 Hours",
      www: "",
    },
  ],

  sporting: [
    {
      id: 82,
      name: "Bamboo Rafting",
      description:
        "Bamboo rafting on the Kabini River at Kuruva Island, a forested river island near Mananthavady managed for visitors by DTPC Wayanad.",
      image: [
        "https://www.bwstays.com/assets/img/sports/bw-stay-bamboo-sport-rafting-wayanad.webp",
      ],
      holidays: "Mon",
      timing: ["09:00-16:30"],
      Contact: "+91 75938 92956",
      seasontovisit: [
        "Summer (March-May)",
        "Monsoon (June-September)",
        "Winter (October-February)",
      ],
      distance: "31",
      latlong: "11.8226516, 76.0898492",
      map: "https://www.google.com/maps/place/Longest+Zipline%2C+Sky+cycle+%26+Giant+Swing/@11.5039073,76.1459707,17z",
      transport: "Public",
      rating: "",
      hrs: "2",
      fee: "Rafting INR 100 adult, INR 50 child (20 min); Kuruva Island entry INR 220 adult, INR 100 student, INR 440 foreigner",
      aliases: [],
      content:
        "Visitors reach Kuruva Island, an uninhabited forested island of about 950 acres in the Kabini, by fibre boat or bamboo raft. DTPC lists 20-minute rafting rides as well as kayaking and paddling. Booking is offline only, the daily number of visitors is capped, and the island closes in the monsoon (June to September).",
      amenities: [
        "Kayak Equipment",
        "Safety Gear",
        "Local Guide",
        "Refreshments",
      ],
      tags: [
        "backwater",
        "kayaking",
        "adventure",
        "wildlife",
        "village",
        "sports",
        "cultural",
        "quiet travel",
      ],

      type: "Sporting",
      knowmore:
        "https://www.bwstays.com/bw-bamboo-rafting-sporting-wayanad.html",

      duration: "2 Hours",
      www: "",
    },
    {
      id: 70,
      name: "Ziplines",
      description: "Zip lines in Wayanad are offered at the Karapuzha Dam adventure park and at the 900 Kandi Skypark, each with its own ticket.",
      image: [
        "https://www.bwstays.com/assets/img/sports/bw-stay-zipline-vytiri-wayanad.webp",
      ],
      holidays: "NA",
      timing: [],
      Contact: "",
      seasontovisit: [
        "Summer (March-May)",
        "Monsoon (June-September)",
        "Winter (October-February)",
      ],
      distance: "10",
      latlong: "11.6076643, 76.1350769",
      map: "https://www.google.com/maps/place/Longest+Zipline%2C+Sky+cycle+%26+Giant+Swing/@11.5039073,76.1459707,17z",
      transport: "Public",
      rating: "",
      hrs: "2",
      fee: "",
      aliases: [],
      content:
        "DTPC lists a zip line at Karapuzha Dam (INR 390, riders 40 kg+, park open 09:00-18:00, with a giant swing at INR 280) and at Skypark, 900 Kandi (INR 350). Other private zip lines operate around Vythiri and Karlad but have no official listing. This entry should point to a specific operator.",
      amenities: [
        "Kayak Equipment",
        "Safety Gear",
        "Local Guide",
        "Refreshments",
      ],
      tags: [
        "backwater",
        "kayaking",
        "adventure",
        "wildlife",
        "village",
        "sports",
        "cultural",
        "quiet travel",
      ],
      type: "Sporting",
      knowmore: "https://www.bwstays.com/bw-ziplines-sporting-wayanad.html",
      duration: "1-2 Hours",
      www: "",
    },

  ],
  food: [
    {
      id: 60,
      name: "Kalpetta Food Spots",
      description:
        "A guide to places to eat in and around Kalpetta, listed on the site's food page.",
      image: [
        "https://www.bwstays.com/assets/img/food/bw-kalpetta-food-drinks-collage-all-images.webp",
      ],
      holidays: "NA",
      timing: [],
      Contact: "",
      seasontovisit: ["All Season"],
      distance: "5",
      transport: "Public",
      latlong: "",
      map: "",
      rating: "",
      hrs: "2",
      fee: "",
      aliases: [],
      content:
        "This entry is a section of the site rather than a single venue. The food page lists individual eateries with their own details; hours and phones belong to each place, not to the section.",
      amenities: [
        "Cooking Equipment",
        "Recipe Book",
        "Spice Kit",
        "Traditional Methods",
      ],
      tags: [
        "cooking classes",
        "kerala dishes",
        "spices",
        "market visits",
        "hands-on",
        "authentic",
      ],
      type: "Food",
      knowmore: "https://www.bwstays.com/all-fooding-wayanad.html",
      duration: "1-2 Hours",
      www: "",
    },

    {
      id: 65,
      name: "Restaurants",
      description:
        "A general section on restaurants near Kalpetta; individual eateries and their details are listed on the site's food page.",
      image: [
        "https://www.bwstays.com/assets/img/food/bw-stays-hotel-wayanad-inn.webp",
      ],
      holidays: "NA",
      timing: [],
      Contact: "",
      seasontovisit: ["All Season"],
      distance: "10",
      transport: "Public",
      latlong: "",
      map: "",
      rating: "",
      hrs: "2",
      fee: "",
      aliases: [],
      content:
        "This entry does not describe a single venue. Opening hours, prices and phone numbers belong to each listed restaurant.",
      amenities: [
        "Cooking Equipment",
        "Recipe Book",
        "Spice Kit",
        "Traditional Methods",
      ],
      tags: [
        "cooking classes",
        "kerala dishes",
        "spices",
        "market visits",
        "hands-on",
        "authentic",
      ],
      type: "Food",
      knowmore: "https://www.bwstays.com/bw-restaurants-food-wayanad.html",
      duration: "1-2 Hours",
      www: "",
    },
  ],
  tribal: [
    {
      id: 59,
      name: "Uravu",
      description: "A non-profit bamboo centre at Thrikkaipetta, about 10 km from Kalpetta, with a bamboo nursery, craft workshop and shop.",
      image: [
        "https://www.bwstays.com/assets/img/tribal/bw-bamboo-uravu-thrikkaipetta-wayanad.webp",
        "https://www.bwstays.com/assets/img/tribal/bw-workation-uravu-thrikkaipetta-bamboo-wayanad-1.webp",
        "https://www.bwstays.com/assets/img/tribal/bw-stay-uravu-thrikkaipetta-wayanad-factory.webp",
        "https://www.bwstays.com/assets/img/tribal/bw-service-apartment-uravu-thrikkaipetta-bamboo-wayanad.webp",
      ],
      holidays: "NA",
      timing: ["09:30-18:30"],
      Contact: "",
      seasontovisit: [
        "Summer (March-May)",
        "Monsoon (June-September)",
        "Winter (October-February)",
      ],
      distance: "11",
      latlong: "11.6076643, 76.1350769",
      map: "https://www.google.com/maps/place/Uravu+Indigenous+Science+%26+Technology+Study+Centre/@11.6081186,76.1337973,17z",
      transport: "Public",
      rating: "",
      hrs: "2",
      fee: "No entry fee",
      aliases: [],
      content:
        "Uravu has worked since 1996 to revive bamboo crafts and livelihoods in Thrikkaipetta, the 'bamboo village'. Visitors can walk the bamboo plantations, take a guided tour of the processing workshop and buy furniture and handicrafts; a second outlet is near Pookode Lake. Kerala Tourism (August 2024) gives daily opening 09:30-18:30, no entry fee.",
      amenities: [
        "Tribal Communities",
        "Tribal History",
        "Cultural Preservation",
        "Languages",
      ],
      tags: [
        "Tribal Festivals",
        "Music",
        "Crafts",
        "Wisdom",
        "Ethnic Diversity",
        "Oral Traditions",
      ],

      type: "Tribal",
      knowmore: "https://www.bwstays.com/bw-uravu-bamboo-tribal-wayanad.html",

      duration: "1-2 Hours",
      www: "",
    },
    {
      id: 57,
      name: "En ooru",
      description: "Kerala's first tribal heritage village, at Pookode near Vythiri, with traditional huts, performances and tribal craft stalls.",
      image: [
        "https://www.bwstays.com/assets/img/tribal/bw-homestay-en-ooru-tribal-heritage-village-wayanad.webp",
      ],
      holidays: "NA",
      timing: ["09:00-17:00 (Mon-Fri)", "09:00-18:00 (Sat, Sun, holidays)"],
      Contact: "+91 62380 71371",
      seasontovisit: [
        "Summer (March-May)",
        "Monsoon (June-September)",
        "Winter (October-February)",
      ],
      distance: "16",
      latlong: "11.52992082510649, 76.01545167598373",
      map: "https://www.google.com/maps/place/En+Ooru/@11.5296875,76.0154375,17z",
      transport: "Public",
      rating: "",
      hrs: "2",
      fee: "Adult INR 50 (camera INR 150, shuttle INR 40)",
      aliases: [],
      content:
        "Enooru at Pookode, about 5.6 km from Vythiri bus stand, presents the customs, architecture and crafts of Wayanad's tribal communities. Visitors see traditional huts, an amphitheatre with tribal music and dance, and stalls selling tribal medicines, handicrafts and products. A shuttle jeep runs up to the village; tickets are sold offline only.",
      amenities: [
        "Tribal Communities",
        "Tribal History",
        "Cultural Preservation",
        "Languages",
      ],
      tags: [
        "Tribal Festivals",
        "Music",
        "Crafts",
        "Wisdom",
        "Ethnic Diversity",
        "Oral Traditions",
      ],

      type: "Tribal",
      knowmore: "https://www.bwstays.com/bw-en-ooru-tribal-wayanad.html",

      duration: "1-2 Hours",
      www: "",
    },
  ],

  cycling: [],

  shopping: [

    {
      "id": 91,
      "name": "The Tribal Spot Near the Forest",
      "description": "Shopping place at Kunnathidavaka, Wayanad, Kerala.",
      "image": [
        "https://www.bwstays.com/assets/img/tribal/bw-homestay-en-ooru-tribal-heritage-village-wayanad.webp"
      ],
      "holidays": "NA",
      "timing": [],
      "Contact": "",
      "seasontovisit": [],
      "distance": "",
      "transport": "",
      "latlong": "",
      "map": "https://www.google.com/maps/search/?api=1&query=The+Tribal+Spot+Near+the+Forest+Kunnathidavaka+Wayanad+Kerala",
      "rating": "",
      "hrs": "",
      "fee": "",
      "aliases": [],
      "content": "The Tribal Spot Near the Forest is a shopping place at Kunnathidavaka, Wayanad, Kerala. Opening hours, contact details and photos will be added once they are confirmed.",
      "amenities": [],
      "tags": [
        "shopping",
        "wayanad",
        "local products",
        "kunnathidavaka"
      ],
      "type": "shopping",
      "knowmore": "https://www.google.com/maps/search/?api=1&query=The+Tribal+Spot+Near+the+Forest+Kunnathidavaka+Wayanad+Kerala",
      "duration": "",
      "www": ""
    },
    {
      "id": 92,
      "name": "Government & Cooperative Trust Places",
      "description": "Handicraft and spice shops at the entrance of Pookode Lake, near Vythiri, in the DTPC-run lake area.",
      "image": [
        "https://www.bwstays.com/assets/img/shopping/photo-coming-soon.svg"
      ],
      "holidays": "NA",
      "timing": [],
      "Contact": "",
      "seasontovisit": [],
      "distance": "",
      "transport": "",
      "latlong": "",
      "map": "https://www.google.com/maps/search/?api=1&query=Government+%26+Cooperative+Trust+Places+Pookode%2C+Kunnathidavaka+Wayanad+Kerala",
      "rating": "",
      "hrs": "",
      "fee": "",
      "aliases": [],
      "content": "Pookode Lake, about 3 km south of Vythiri and 15 km from Kalpetta, is run by DTPC Wayanad within the South Wayanad forest division. A shop at the entrance sells handmade soap, Ayurvedic products and crafts, and there is a handicrafts and spices emporium among the lake's facilities.",
      "amenities": [],
      "tags": [
        "shopping",
        "wayanad",
        "local products",
        "pookode"
      ],
      "type": "shopping",
      "knowmore": "https://www.google.com/maps/search/?api=1&query=Government+%26+Cooperative+Trust+Places+Pookode%2C+Kunnathidavaka+Wayanad+Kerala",
      "duration": "",
      "www": ""
    },
    {
      "id": 93,
      "name": "Scheduled Tribe Cooperative Society Outlet",
      "description": "Scheduled Tribes cooperative society at Kalloor near Sulthan Bathery that buys forest produce such as wild honey from tribal collectors.",
      "image": [
        "https://www.bwstays.com/assets/img/shopping/photo-coming-soon.svg"
      ],
      "holidays": "NA",
      "timing": [],
      "Contact": "",
      "seasontovisit": [],
      "distance": "",
      "transport": "",
      "latlong": "",
      "map": "https://www.google.com/maps/search/?api=1&query=Scheduled+Tribe+Cooperative+Society+Outlet+Kalloor+Wayanad+Kerala",
      "rating": "",
      "hrs": "",
      "fee": "",
      "aliases": [],
      "content": "The Sulthan Bathery Scheduled Tribes Cooperative Society at Kallur has been described as the largest tribal society in Kerala; it procures wild honey gathered from rock-bee hives, largely by Kattunayakan collectors. No source confirms a retail outlet, its hours or contact.",
      "amenities": [],
      "tags": [
        "shopping",
        "wayanad",
        "local products",
        "kalloor"
      ],
      "type": "shopping",
      "knowmore": "https://www.google.com/maps/search/?api=1&query=Scheduled+Tribe+Cooperative+Society+Outlet+Kalloor+Wayanad+Kerala",
      "duration": "",
      "www": ""
    },
    {
      "id": 94,
      "name": "Wayanad Heritage Museum Shop",
      "description": "Shopping place at Ambalavayal, Wayanad, Kerala.",
      "image": [
        "https://www.bwstays.com/assets/img/shopping/photo-coming-soon.svg"
      ],
      "holidays": "NA",
      "timing": [],
      "Contact": "",
      "seasontovisit": [],
      "distance": "",
      "transport": "",
      "latlong": "",
      "map": "https://www.google.com/maps/search/?api=1&query=Wayanad+Heritage+Museum+Shop+Ambalavayal+Wayanad+Kerala",
      "rating": "",
      "hrs": "",
      "fee": "",
      "aliases": [],
      "content": "Wayanad Heritage Museum Shop is a shopping place at Ambalavayal, Wayanad, Kerala. Opening hours, contact details and photos will be added once they are confirmed.",
      "amenities": [],
      "tags": [
        "shopping",
        "wayanad",
        "local products",
        "ambalavayal"
      ],
      "type": "shopping",
      "knowmore": "https://www.google.com/maps/search/?api=1&query=Wayanad+Heritage+Museum+Shop+Ambalavayal+Wayanad+Kerala",
      "duration": "",
      "www": ""
    },
    {
      "id": 95,
      "name": "Vanamoolika Herbals",
      "description": "Wayanad farmers' and women's collective, started in 1991 to protect native medicinal plants, that grows and sells organic herbs and spices.",
      "image": [
        "https://www.bwstays.com/assets/img/shopping/photo-coming-soon.svg"
      ],
      "holidays": "NA",
      "timing": [],
      "Contact": "",
      "seasontovisit": [],
      "distance": "",
      "transport": "",
      "latlong": "",
      "map": "https://www.google.com/maps/search/?api=1&query=Vanamoolika+Herbals+Mullenkolly%2C+Pulpally+Wayanad+Kerala",
      "rating": "",
      "hrs": "",
      "fee": "",
      "aliases": [],
      "content": "Vanamoolika began in 1991 when a group of 14 farmers came together to safeguard native medicinal plants; it has trained around 250 women to grow and market them. It supplies organic spices, rice and coffee to buyers abroad through a sister company, Indian Organic Farmers' Producer Company. Whether it runs a shop at Mullankolly/Pulpally is not confirmed.",
      "amenities": [],
      "tags": [
        "shopping",
        "wayanad",
        "local products",
        "mullenkolly"
      ],
      "type": "shopping",
      "knowmore": "https://www.google.com/maps/search/?api=1&query=Vanamoolika+Herbals+Mullenkolly%2C+Pulpally+Wayanad+Kerala",
      "duration": "",
      "www": ""
    },
  ],

  pilgrimage: [
    {
      id: 4,
      name: "Tirunelli",
      description:
        "Ancient Maha Vishnu temple at Thirunelli, set in forest beside the Brahmagiri hills, about 32 km from Mananthavady.",
      image: [
        "https://www.bwstays.com/assets/img/pilgrimage/bw-stays-tirunelli-temple-wayanad.webp",
        "https://www.bwstays.com/assets/img/pilgrimage/bw-stays-thirunelli-temple_wayanad.webp",
        "https://www.bwstays.com/assets/img/pilgrimage/bw-stays-thirunelli-temple-wayanad.webp",
      ],
      holidays: "NA",
      timing: ["05:30-12:00", "17:30-20:00"],
      Contact: "",
      seasontovisit: [
        "Summer (March-May)",
        "Monsoon (June-September)",
        "Winter (October-February)",
      ],
      distance: "48",
      transport: "Public",
      rating: "",
      hrs: "2",
      fee: "",
      aliases: [],
      latlong: "11.9116989, 75.995828",
      map: "https://www.google.com/maps/place/Sree+Thirunelli+Mahavishnu+Temple/@11.9116989,75.995828,17z",
      content:
        "The temple is dedicated to Vishnu in his four-armed form and is also called Sahyamala Kshetram and 'Kashi of the South'. It has granite pillars and stone aqueducts that bring water from the hills. Devotees perform rites for ancestors at the Papanasini stream, about 1 km away, and the temple pond Panchatheertham holds a rock called Vishnupada.",
      amenities: [
        "Tribal Religion",
        "Nature Worship",
        "Indigenous Beliefs",
        "Wayanad Tribes",
      ],
      tags: ["Church", "temple", "mosque", "yoga", "festivals"],
      type: "Pilgrimage",
      knowmore:
        "https://www.bwstays.com/bw-tirunelli-temple-pilgrimage-wayanad.html",

      duration: "1-2 Hours",
      www: "",
    },

    {
      id: 2,
      name: "Ananthanatha Swamy Jain",
      description:
        "Jain temple of Tirthankara Ananthanatha Swami on Puliyarmala hillock, about 5 km from Kalpetta.",
      image: [
        "https://www.bwstays.com/assets/img/pilgrimage/bw-stays-anantha-swami-jain-temple-wayanad.webp",
      ],
      holidays: "NA",
      timing: [],
      Contact: "",
      latlong: "11.641044660114158, 76.08687012883617",
      map: "https://www.google.com/maps/place/Ananthanatha+Swamy+Jain+Temple/@11.6409028,76.0868594,17z",
      seasontovisit: [
        "Summer (March-May)",
        "Monsoon (June-September)",
        "Winter (October-February)",
      ],
      distance: "4",
      transport: "Public",
      rating: "",
      hrs: "2",
      fee: "",
      aliases: [],
      content:
        "The temple is dedicated to Ananthanatha Swami, a Jain Tirthankara. It is believed to have first stood in old Kalpetta (Kalpavathy) and was moved to the Puliyarmala hillock by Mandappa Gowder in 1931. DTPC Wayanad notes that the main idol of the Sultan Bathery Jain temple is now kept here.",
      amenities: [
        "Tribal Religion",
        "Nature Worship",
        "Indigenous Beliefs",
        "Wayanad Tribes",
      ],
      tags: ["Church", "temple", "mosque", "yoga", "festivals"],
      type: "Pilgrimage",
      knowmore:
        "https://www.bwstays.com/bw-ananthanatha-swamy-jain-temple-pilgrimage-wayanad.html",

      duration: "1-2 Hours",
      www: "",
    },
    {
      id: 3,
      name: "Koottamundu Glass Temple Wayanad",
      description:
        "Jain temple of Parswanatha Swami on the slopes of Vellarimala near Koottamunda, known for its mirror-lined inner walls.",
      image: [
        "https://www.bwstays.com/assets/img/pilgrimage/bw-workation-jain-glass-temple-wayanad.webp",
      ],
      holidays: "NA",
      timing: [],
      Contact: "",
      seasontovisit: [
        "Summer (March-May)",
        "Monsoon (June-September)",
        "Winter (October-February)",
      ],
      distance: "20",
      transport: "Public",
      latlong: "11.571875045855256, 76.08657265424115",
      map: "https://www.google.com/maps/place/Koottamundu%2C+Kottappadi+part%2C+Kerala/@11.5706902,76.087051,17z",
      rating: "",
      hrs: "2",
      fee: "",
      aliases: [],
      content:
        "The temple, about 20 km from Kalpetta, is dedicated to Parswanatha Swami. Its sanctum holds icons of Parswanatha Swami and Padmavathi Devi, and mirrors on the inner walls reflect the idols in repeating patterns, which gives it the name Glass Temple.",
      amenities: [
        "Tribal Religion",
        "Nature Worship",
        "Indigenous Beliefs",
        "Wayanad Tribes",
      ],
      tags: ["Church", "temple", "mosque", "yoga", "festivals"],
      type: "Pilgrimage",
      knowmore:
        "https://www.bwstays.com/bw-koottamundu-glass-temple-pilgrimage-wayanad.html",

      duration: "1-2 Hours",
      www: "",
    },

    {
      id: 5,
      name: "Papanasini River",
      description:
        "Sacred mountain stream from the Brahmagiri hills, about 1 km from Thirunelli temple, where devotees perform rites for ancestors.",
      image: [
        "https://www.bwstays.com/assets/img/pilgrimage/bw-stays-papanasini-wayanad-tourist.webp",
        "https://www.bwstays.com/assets/img/pilgrimage/bw-staycation-papanashini-wayanad.webp",
        "https://www.bwstays.com/assets/img/pilgrimage/bw-stays-papanasini-thirunelli-wayanad.webp",
      ],
      holidays: "NA",
      timing: [],
      Contact: "",
      seasontovisit: [
        "Summer (March-May)",
        "Monsoon (June-September)",
        "Winter (October-February)",
      ],
      distance: "49",
      transport: "Public",
      rating: "",
      hrs: "2",
      fee: "",
      aliases: [],
      latlong: "11.911882611618777, 75.99584945767235",
      map: "https://www.google.com/maps/place/Sree+Thirunelli+Mahavishnu+Temple/@11.9116989,75.995828,17z",
      content:
        "Papanasini flows down from Brahmagiri near the Thirunelli Maha Vishnu temple. By tradition its water washes away sins, and devotees bathe in it and offer rites (bali, pinda) for ancestors on its banks. It is reached on foot from the temple.",
      amenities: [
        "Tribal Religion",
        "Nature Worship",
        "Indigenous Beliefs",
        "Wayanad Tribes",
      ],
      tags: ["Church", "temple", "mosque", "yoga", "festivals"],
      type: "Pilgrimage",
      knowmore:
        "https://www.bwstays.com/bw-papanasini-river-temple-pilgrimage-wayanad.html",

      duration: "1-2 Hours",
      www: "",
    },
    {
      id: 7,
      name: "Meenangadi Church",
      description:
        "Syriac Orthodox Marian pilgrim church at Meenangadi, known for the relic of St. Mary's girdle (Soonoro).",
      image: [
        "https://www.bwstays.com/assets/img/pilgrimage/bw-staycation-meenagadhi-church-wayanad.webp",
      ],
      holidays: "NA",
      timing: [],
      Contact: "",
      seasontovisit: [
        "Summer (March-May)",
        "Monsoon (June-September)",
        "Winter (October-February)",
      ],
      distance: "14",
      transport: "Public",
      rating: "",
      hrs: "2",
      fee: "",
      aliases: [],
      latlong: "11.65965314607536, 76.17374499957178",
      map: "https://www.google.com/maps/place/St.+Peter's+%26+St.+Paul's+Jacobite+Syrian+Cathedral/@11.6590982,76.1735335,17z",
      content:
        "St. Mary's church at Meenangadi belongs to the Syriac Orthodox Church and was consecrated on 1 February 1958. It holds the Holy Soonoro (girdle of St. Mary), installed in 1991, and relics of Patriarch Ignatius Elias III. Its main feast is the eight-day lent and Nativity of St. Mary feast, 1 to 8 September.",
      amenities: [
        "Tribal Religion",
        "Nature Worship",
        "Indigenous Beliefs",
        "Wayanad Tribes",
      ],
      tags: ["Church", "temple", "mosque", "yoga", "festivals"],
      type: "Pilgrimage",
      knowmore:
        "https://www.bwstays.com/bw-meenangadi-church-pilgrimage-wayanad.html",

      duration: "1-2 Hours",
      www: "",
    },
    {
      id: 8,
      name: "Our Lady of Lourdes Shrine, Pallikunnu",
      description:
        "Latin Catholic church of Our Lady of Lourdes at Pallikunnu, founded in 1908 by the French priest Fr. Jefreno.",
      image: [
        "https://www.bwstays.com/assets/img/pilgrimage/bw-stays-pallikunnu-church-wayanad.webp",
        "https://www.bwstays.com/assets/img/pilgrimage/bw-workation-pallikkunnu-church-wayanad.webp",
      ],
      holidays: "NA",
      timing: ["07:00-19:00"],
      Contact: "+91 493 628 6623",
      seasontovisit: [
        "Summer (March-May)",
        "Monsoon (June-September)",
        "Winter (October-February)",
      ],
      distance: "14",
      transport: "Public",
      rating: "",
      hrs: "2",
      fee: "",
      aliases: [],
      latlong: "11.685229537534148, 76.05606037116382",
      map: "https://www.google.com/maps/place/OUR+LADY+OF+LOURDES+SHRINE%2C+PALLIKUNNU/@11.6850877,76.0560711,17z",
      content:
        "The church, known as Pallikunnu Church, was established in 1908 by Fr. Jefreno, a French priest, and follows some local Hindu customs. Its annual festival runs for three days from 10 February. DTPC lists it as about 10 km from Kalpetta.",
      amenities: [
        "Tribal Religion",
        "Nature Worship",
        "Indigenous Beliefs",
        "Wayanad Tribes",
      ],
      tags: ["Church", "temple", "mosque", "yoga", "festivals"],
      type: "Pilgrimage",
      knowmore:
        "https://www.bwstays.com/bw-our-lady-of-lourdes-shrine-pilgrimage-wayanad.html",

      duration: "1-2 Hours",
      www: "",
    },
    {
      id: 9,
      name: "Pulpally Sitadevi temple",
      description: "18th-century temple at Pulpally, one of the few in Kerala dedicated to Seetha Devi, with idols of Lava and Kusa.",
      image: [
        "https://www.bwstays.com/assets/img/pilgrimage/bw-seetha-lava-kusha-temple-wayanad.webp",
      ],
      holidays: "NA",
      timing: ["05:00-12:30","17:30-19:30"],
      Contact: "+91 493 624 1175",
      seasontovisit: [
        "Summer (March-May)",
        "Monsoon (June-September)",
        "Winter (October-February)",
      ],
      distance: "30",
      transport: "Public",
      rating: "",
      hrs: "2",
      fee: "",
      aliases: [],
      latlong: "11.793030398758432, 76.16871715767236",
      map: "https://www.google.com/maps/place/Sree+Seethadevi+Lava+Kusha+Temple+Pulpally/@11.7928151,76.1686957,17z",
      content:
        "The temple stands about 280 m from Pulpally bus stand and is managed by the Malabar Devaswom Board, with a member of the Kuppathode family as trustee. It is one of the few temples in Kerala dedicated to Seetha, and it also has idols of her sons Lava and Kusa, linking it to local Ramayana traditions.",
      amenities: [
        "Tribal Religion",
        "Nature Worship",
        "Indigenous Beliefs",
        "Wayanad Tribes",
      ],
      tags: ["Church", "temple", "mosque", "yoga", "festivals"],
      type: "Pilgrimage",
      knowmore:
        "https://www.bwstays.com/bw-pulpally-sitadevi-temple-pilgrimage-wayanad.html",

      duration: "1-2 Hours",
      www: "",
    },
    {
      id: 10,
      name: "Trikaipatta temple",
      description: "Shiva temple at Thrikkaipatta near Meppadi, Wayanad, with shrines to Ganesha, Ayyappa and the serpent deities.",
      image: [
        "https://www.bwstays.com/assets/img/pilgrimage/bw-stays-trikaipattta-temple-wayanad.webp",
      ],
      holidays: "NA",
      timing: [],
      Contact: "",
      seasontovisit: [
        "Summer (March-May)",
        "Monsoon (June-September)",
        "Winter (October-February)",
      ],
      distance: "12",
      transport: "Public",
      rating: "",
      hrs: "2",
      fee: "",
      aliases: [],
      latlong: "11.6057586, 76.133523",
      map: "https://www.google.com/maps/place/Sree+Thrikkaipetta+Shiva+Temple/@11.606146,76.134439,17z",
      content:
        "Kerala Tourism lists the temple as dedicated to Lord Shiva, with idols of Ganesha, Ayyappa and Naga (serpent god). The name Thrikkaipatta is explained as 'bands on three hands' in Malayalam. No official timings or history are published.",
      amenities: [
        "Tribal Religion",
        "Nature Worship",
        "Indigenous Beliefs",
        "Wayanad Tribes",
      ],
      tags: ["Church", "temple", "mosque", "yoga", "festivals"],
      type: "Pilgrimage",
      knowmore:
        "https://www.bwstays.com/bw-trikaipatta-temple-pilgrimage-wayanad.html",

      duration: "1-2 Hours",
      www: "",
    },
    {
      id: 11,
      name: "Trishileri temple ",
      description:
        "Ancient Shiva temple about 8 km north-west of Mananthavady, ritually linked to the Thirunelli temple.",
      image: [
        "https://www.bwstays.com/assets/img/pilgrimage/bw-workation-trishilerry-temple-wayanad.webp",
        "https://www.bwstays.com/assets/img/pilgrimage/bw-stays-trishilerry-temple-wayanad.webp",
      ],
      holidays: "NA",
      timing: ["06:00-12:30","17:00-19:30"],
      Contact: "+91 493 525 0325",
      seasontovisit: [
        "Summer (March-May)",
        "Monsoon (June-September)",
        "Winter (October-February)",
      ],
      distance: "36",
      transport: "Public",
      latlong: "11.8516904520993, 76.01646686931055",
      map: "https://www.google.com/maps/place/V228+JJ9+Thrissilery+Shiva+Temple%2C+Thrissilery+Rd%2C+Thrishilery%2C+Kerala+670646/@11.8514777,76.0165694,17z",
      rating: "",
      hrs: "2",
      fee: "",
      aliases: [],
      content:
        "Kerala Tourism calls it one of the oldest temples in Kerala, with Lord Shiva as presiding deity. Ancestral rites at Thirunelli are traditionally completed with an offering here, and a small Jala Durga shrine stands in a water body fed from the Papanasini at Thirunelli. The annual festival falls in Meenam (March-April).",
      amenities: [
        "Tribal Religion",
        "Nature Worship",
        "Indigenous Beliefs",
        "Wayanad Tribes",
      ],
      tags: ["Church", "temple", "mosque", "yoga", "festivals"],
      type: "Pilgrimage",
      knowmore:
        "https://www.bwstays.com/bw-trishileri-temple-pilgrimage-wayanad.html",

      duration: "1-2 Hours",
      www: "",
    },

    {
      id: 12,
      name: "Sita Lav Kush Temple ponkuzhy",
      description:
        "Ramayana-linked temple beside the Ponkuzhi river on the Sulthan Bathery-Mysore road, about 4 km from Muthanga.",
      image: [
        "https://www.bwstays.com/assets/img/pilgrimage/bw-stays-lava-kush-ponkuzhi-wayanad.webp",
        "https://www.bwstays.com/assets/img/pilgrimage/bw-seetha-lava-kusha-temple-wayanad.webp",
        "https://www.bwstays.com/assets/img/pilgrimage/bw-stays-lav-kush-temple-wayanad.webp",
      ],
      holidays: "NA",
      timing: [],
      Contact: "",
      seasontovisit: [
        "Summer (March-May)",
        "Monsoon (June-September)",
        "Winter (October-February)",
      ],
      distance: "41",
      transport: "Public",
      latlong: "11.695157523716542, 76.39100128986541",
      map: "https://www.google.com/maps/place/Ponkuzhi+temple+and+Seeta+Rama+temple/@11.6887172,76.3922179,17z",
      rating: "",
      hrs: "2",
      fee: "",
      aliases: [],
      content:
        "Kerala Tourism lists the Ponkuzhi Sree Rama temple, where Rama, Sita, Lakshmana and Hanuman are worshipped, and a Seetha Devi-Hanuman temple at the same spot. Both are tiled-roof Kerala-style shrines by the Ponkuzhi river. Local myth says the temple pond was formed by Sita's tears.",
      amenities: [
        "Tribal Religion",
        "Nature Worship",
        "Indigenous Beliefs",
        "Wayanad Tribes",
      ],
      tags: ["Church", "temple", "mosque", "yoga", "festivals"],
      type: "Pilgrimage",
      knowmore:
        "https://www.bwstays.com/bw-sita-lav-kush-temple-pilgrimage-wayanad.html",

      duration: "1-2 Hours",
      www: "",
    },

    {
      id: 13,
      name: "Varampatta mosque",
      description:
        "Mosque at Varambetta in Padinjarathara panchayat, described by Kerala Tourism as one of Wayanad's oldest, about 300 years old.",
      image: [
        "https://www.bwstays.com/assets/img/pilgrimage/bw-stays-korome-mosque-wayanad.webp",
        "https://www.bwstays.com/assets/img/pilgrimage/bw-stays-varambetta-mosque-wayanad.webp",
        "https://www.bwstays.com/assets/img/pilgrimage/bw-workation-korome-mosque-wayanad.webp",
        "https://www.bwstays.com/assets/img/pilgrimage/bw-stays-wayanad-varambetta-mosque.webp",
      ],
      holidays: "NA",
      timing: [],
      Contact: "",
      seasontovisit: [
        "Summer (March-May)",
        "Monsoon (June-September)",
        "Winter (October-February)",
      ],
      distance: "21",
      transport: "Public",
      latlong: "11.69008127287275, 75.95892924232764",
      map: "https://www.google.com/maps/place/Varambetta+Makham+%E0%B4%B5%E0%B4%BE%E0%B4%B0%E0%B4%BE%E0%B4%AE%E0%B5%8D%E0%B4%AA%E0%B4%B1%E0%B5%8D%E0%B4%B1+%E0%B4%AE%E0%B4%96%E0%B4%BE%E0%B4%82/@11.6898764,75.9589507,17z",
      rating: "",
      hrs: "2",
      fee: "",
      aliases: [],
      content:
        "Kerala Tourism lists Varambetta as one of the oldest mosques in the district, about 300 years old by traditional estimate, around 15 km from Kalpetta. A Kerala Tourism festival brochure places it in Padinjarathara panchayat and lists an annual festival (nercha) in late March.",
      amenities: [
        "Tribal Religion",
        "Nature Worship",
        "Indigenous Beliefs",
        "Wayanad Tribes",
      ],
      tags: ["Church", "temple", "mosque", "yoga", "festivals"],
      type: "Pilgrimage",
      knowmore:
        "https://www.bwstays.com/bw-varampatta-mosque-pilgrimage-wayanad.html",

      duration: "1-2 Hours",
      www: "",
    },
    {
      id: 14,
      name: "Valliyoorkavu temple",
      description:
        "Bhagavathy temple near Mananthavady where Durga is worshipped as Vana Durga, Bhadrakali and Jala Durga.",
      image: [
        "https://www.bwstays.com/assets/img/pilgrimage/bw-valliyurkavu-bhagavathy-temple-wayanad.webp",
        "https://www.bwstays.com/assets/img/pilgrimage/bw-stays-resort-valliyurkavu-wayanad.webp",
        "https://www.bwstays.com/assets/img/pilgrimage/bw-valliyoorkavu-homestay-wayanad.webp",
        "https://www.bwstays.com/assets/img/pilgrimage/bw-valliyoorkavu-bhagavathy-temple-wayanad.webp",
      ],
      holidays: "NA",
      timing: ["06:00-12:30","17:30-20:00"],
      Contact: "+91 493 524 0084",
      seasontovisit: [
        "Summer (March-May)",
        "Monsoon (June-September)",
        "Winter (October-February)",
      ],
      distance: "27",
      transport: "Public",
      latlong: "11.802496912934904, 76.02997277047147",
      map: "https://www.google.com/maps/place/Valliyoorkavu%2C+Mananthavady%2C+Kerala+670645/@11.8039844,76.0290366,17z",
      rating: "",
      hrs: "2",
      fee: "",
      aliases: [],
      content:
        "The temple dates to the 14th century and is known for a 14-day festival in Meenam (March-April) that starts when the sword of Valliyooramma is brought from Pandikkadavu; tribal chieftains hoist the flag on the seventh day. It is about 4 km from Mananthavady bus stand.",
      amenities: [
        "Tribal Religion",
        "Nature Worship",
        "Indigenous Beliefs",
        "Wayanad Tribes",
      ],
      tags: ["Church", "temple", "mosque", "yoga", "festivals"],
      type: "Pilgrimage",
      knowmore:
        "https://www.bwstays.com/bw-valliyoorkavu-temple-pilgrimage-wayanad.html",

      duration: "1-2 Hours",
      www: "",
    },
  ],
  health: [
    {
      id: 97,
      name: "Keluvaidyar, Kattikulam",
      description: "Keluvaidyar is a traditional herbal healer of the Kurichya tribal community in Kattikulam, a town in the Mananthavady area of Wayanad. The blog reports that people travel to him from other cities, among others for asthma, diabetes and skin conditions such as psoriasis and eczema. Source: the Kallivalli blog post Tribal medicine and its practitioners (2014). Not medical advice; BWStays has not verified these reports. Address, timings, fees and contact are not published; the map position is the area, not the healer's door.",
      image: [
        "https://www.bwstays.com/assets/img/health/bw-keluvaidyar-kattikulam-tribal-healer-wayanad.webp",
      ],
      holidays: "NA",
      timing: [],
      Contact: "",
      seasontovisit: [],
      distance: "34",
      latlong: "11.8481113, 76.0634257",
      map: "",
      transport: "",
      rating: "",
      hrs: "",
      fee: "",
      aliases: ["keluvaidyar", "kelu vaidyar", "kelu vaidyan"],
      content:
        "Keluvaidyar is a traditional herbal healer of the Kurichya tribal community in Kattikulam, a town in the Mananthavady area of Wayanad. The blog reports that people travel to him from other cities, among others for asthma, diabetes and skin conditions such as psoriasis and eczema. Source: the Kallivalli blog post Tribal medicine and its practitioners (2014). Not medical advice; BWStays has not verified these reports. Address, timings, fees and contact are not published; the map position is the area, not the healer's door.",
      amenities: ["Tribal herbal medicine", "Kurichya healer", "Kattikulam, Mananthavady"],
      tags: ["tribal medicine", "herbal healer", "Kurichya", "Kattikulam", "Mananthavady", "Wayanad", "traditional healing", "Keluvaidyar"],
      type: "Health & Wellness",
      knowmore: "https://www.bwstays.com/bw-keluvaidyar-kattikulam-health-wayanad.html",
      duration: "",
      www: "",
    },
    {
      id: 96,
      name: "Vellanvaidyar, Thirunelli",
      description: "Vellanvaidyar is a traditional herbal healer of the Kurichya tribal community, described as practising at the foot of the Thirunelli temple in northern Wayanad. The blog reports that people travel to him for a range of ailments, among them asthma, diabetes and bone fractures. Source: the Kallivalli blog post Tribal medicine and its practitioners (2014). Not medical advice; BWStays has not verified these reports. Address, timings, fees and contact are not published; the map position is the area, not the healer's door.",
      image: [
        "https://www.bwstays.com/assets/img/health/bw-vellanvaidyar-thirunelli-tribal-healer-wayanad.webp",
      ],
      holidays: "NA",
      timing: [],
      Contact: "",
      seasontovisit: [],
      distance: "48",
      latlong: "11.9098981, 75.994875",
      map: "",
      transport: "",
      rating: "",
      hrs: "",
      fee: "",
      aliases: ["vellanvaidyar", "vellan vaidyar", "vellan vaidyan"],
      content:
        "Vellanvaidyar is a traditional herbal healer of the Kurichya tribal community, described as practising at the foot of the Thirunelli temple in northern Wayanad. The blog reports that people travel to him for a range of ailments, among them asthma, diabetes and bone fractures. Source: the Kallivalli blog post Tribal medicine and its practitioners (2014). Not medical advice; BWStays has not verified these reports. Address, timings, fees and contact are not published; the map position is the area, not the healer's door.",
      amenities: ["Tribal herbal medicine", "Kurichya healer", "Near Thirunelli temple"],
      tags: ["tribal medicine", "herbal healer", "Kurichya", "Thirunelli", "Wayanad", "traditional healing", "Vellanvaidyar"],
      type: "Health & Wellness",
      knowmore: "https://www.bwstays.com/bw-vellanvaidyar-thirunelli-health-wayanad.html",
      duration: "",
      www: "",
    },
  ],

  stays: [
    {
      id: 71,
      name: "bwstays",
      description: "Black and White ",
      image: [
        "https://www.bwstays.com/assets/img/stays/bw-stays-old-kalpetta-town.webp",
      ],
      holidays: "Sun",
      timing: ["09:00-17:00"],
      Contact: "+91-000 000 0000",
      seasontovisit: [
        "Summer (March-May)",
        "Monsoon (June-September)",
        "Winter (October-February)",
      ],
      distance: "0",
      latlong: "11.535204719467869, 76.1789395934791",
      map: "https://www.google.com/maps/place/Ripon+Tea+Factory/@11.5349821,76.1790317,17z",
      transport: "Public",
      rating: "",
      hrs: "2",
      fee: "0",
      aliases: [],
      content: " Black and White stay   ",
      amenities: [
        "expansive tea estates",
        "rustic mud trails",
        "sensory delight",
        "Quiet",
      ],
      tags: [
        "Cycling",
        "Challenging Terrain",
        "Stay visible",
        "cyclists",
        "healthy",
        "adventure tour",
      ],
      type: "stays",
      knowmore:
        "https://www.bwstays.com/bw-rippon-tea-estate-plantation-wayanad.html",
      duration: "1-2 Hours",
      www: "",
    },
    {
      id: 72,
      name: "Mananthavady",
      description: "Sample",
      image: [
        "https://www.bwstays.com/assets/img/stays/bw-stays-manathavady.webp",
      ],
      holidays: "Sun",
      timing: ["10:00-21:00"],
      Contact: "+91-000 000 0000",
      seasontovisit: ["All Season"],
      distance: "10",
      transport: "Public",
      latlong: "11.619717987953072, 76.08467260510648",
      map: "https://www.google.com/maps/place/Mananthavady%2C+Kerala+670645/@11.8029358,76.0038554,17z",
      rating: "",
      hrs: "2",
      fee: "0",
      aliases: [],
      content:
        "Authentic spice shopping experiences across Wayanad. Visit local markets, spice gardens, and processing centers. Learn about cardamom, pepper, cinnamon, and other exotic spices that make Kerala cuisine special.",
      amenities: ["Market Access", "Spice Tasting", "Recipe Cards"],
      tags: [
        "spice shopping",
        "guided tours",
        "local markets",
        "cardamom",
        "pepper",
        "cinnamon",
        "kerala cuisine",
      ],

      type: "stays",
      knowmore: "https://www.google.com/maps/place/Mananthavady%2C+Kerala+670645/@11.8029358,76.0038554,17z",
      duration: "1-2 Hours",
      www: "",
    },
    {
      id: 73,
      name: "Sulthan Bathery",
      description: "Sample",
      image: [
        "https://www.bwstays.com/assets/img/stays/bw-stays-sulthan-bathery.webp",
      ],
      holidays: "Sun",
      timing: ["10:00-21:00"],
      Contact: "+91-000 000 0000",
      seasontovisit: ["All Season"],
      distance: "10",
      transport: "Public",
      latlong: "11.619717987953072, 76.08467260510648",
      map: "https://www.google.com/maps/place/Jain+Temple%2C+Sulthan+Bathery/@11.6601663,76.2506633,17z",
      rating: "",
      hrs: "2",
      fee: "0",
      aliases: [],
      content:
        "Authentic spice shopping experiences across Wayanad. Visit local markets, spice gardens, and processing centers. Learn about cardamom, pepper, cinnamon, and other exotic spices that make Kerala cuisine special.",
      amenities: ["Market Access", "Spice Tasting", "Recipe Cards"],
      tags: [
        "spice shopping",
        "guided tours",
        "local markets",
        "cardamom",
        "pepper",
        "cinnamon",
        "kerala cuisine",
      ],

      type: "stays",
      knowmore: "https://www.google.com/maps/place/Jain+Temple%2C+Sulthan+Bathery/@11.6601663,76.2506633,17z",
      duration: "1-2 Hours",
      www: "",
    },
  ],
};
